import React from 'react';

class TermsnConditions extends React.Component {

    render() {
        let { operatorName } = this.props;

        // operatorName 4 => Zong
        // operatorName 5 => Mobilink
        // operatorName 6 => Warid
        // operatorName 7 => Telenor
        // operatorName 8 => Ufone

        if (operatorName) {
        } else {
            operatorName = localStorage.getItem('TriviaUser') ? JSON.parse(localStorage.getItem('TriviaUser')).operatorName : '';
        }

        if (operatorName === "telenor") { //Telenor
            return (
                <div style={{ fontSize: '14px' }} className="px-3 info">
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>1. INTRODUCTION:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <b>1.1</b>  Telenor Pakistan Private Limited (henceforth                <strong>Telenor</strong>) provides telecommunication services in
                    the Islamic Republic of Pakistan, AJK and Gilgit Baltistan (the                <strong>“Territory”</strong>). Telenor is offering various value
                    added services <strong>(“VAS”) </strong>which also<strong> </strong>includes short messaging service (                <strong>“SMS”</strong>);
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <b>1.2</b>  A new feature (the                <strong>“Master Blaster League”</strong>) is being introduced in Cricwick 
                                    “The VAS product”. The Master Blaster League in its introductory
                                    launch period shall be available for a period of 90 days and
                                    may be extended thereafter. The participation in Master Blaster
                                    League is subject to the successful subscription of Cricwick
                                    at PKR 2.5 plus tax (Govt. tax of 19.5% is applicable) per day (defined as                <strong>“Charges”</strong> below);
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="3">
                            <li className="mbrules">
                                <p align="justify">
                                <b>1.3</b>  Telenor is launching a specially designed marketing campaign                <strong>(</strong>the <strong>“Campaign”) </strong>to promote
                                    its VAS Product “Cricwick” and its newly introduced feature
                                    “Master Blaster League”<strong>. </strong>The Campaign includes
                                    incentives for the Customers subscribing to the Cricwick
                                    and engaging in with the Daily Tasks on the platform, including
                                    the free of cost participation in the Trivia and win a wide
                                    array of cash prizes detailed hereunder. The duration of the
                                    Campaign shall be the introductory period of the Master Blaster
                                    League (i.e. 90 days). Telenor has created a webpage
                    http://cricwick.net/_________ (                <strong>“T&amp;C Link”</strong>) and made these Terms and
                                    Conditions (as defined below) available on the Cricwick
                                    mobile app to provide detailed information pertaining to the
                                    Campaign. The Website is publically accessible, whereas the
                                    mobile app shall be accessible to Cricwick subscribers
                                    only;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="4">
                            <li className="mbrules">
                                <p align="justify">
                                <b>1.4</b>  The terms and conditions mentioned herein (                <strong>“Terms and Conditions”</strong>) shall determine the
                                    rights and liabilities of Telenor and the Customer (as defined
                                    below) regarding the Cricwick subscription and also the
                                    Campaign. In order to purchase the subscription to the Telenor
                                    Cricket and consequently also to participate in the Campaign,
                                    the Customer shall accept these Terms and Conditions in their
                                    totality by clicking on the <strong>“Let’s Start”</strong>
                                    button on the Cricwick mobile app and web page. The click
                                    on the button therein, would be for all intents and purposes be
                                    deemed as acceptance on the part of the Customer with these
                                    Terms and Conditions in their totality. The sole consideration
                                    granting the Customer the right to participate in the Campaign
                                    is the subscription to the Cricwick.
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>2. DEFINITIONS AND INTERPRETATIONS:</strong>
                            </p>
                        </li>
                    </li>
                    <p align="justify">
                        <strong>2.1 </strong>
                        <em><strong>Definitions:</strong></em>
                    </p>
                    <p lang="x-none" align="justify">
                        Unless the context requires otherwise, the expressions used in these Terms
                        and Conditions and not defined elsewhere in such Terms and Condition shall
                        have the following meanings assigned to them:
                    </p>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                    <strong>2.1.1 "Advertisement”</strong> or                    <strong>“Advertised by Telenor”</strong> means publication or
                                        advertisement of any information, policy, notice,
                                        intimation, public message or any other communication
                                        regarding the Campaign, collectively or separately, through
                                        any medium including but not limited to digital,
                                        television, radio, outdoor, hoardings/billboards, internet,
                                        cellular and/or print media, SMS Broadcast etc.;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.2 "Terms and Conditions” </strong>means these terms
                                        and conditions;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.3 "Approved modes of communication”</strong> means
                                        any of the modes of communication provided in Telecom
                                        Consumer Protection Regulations, 2009 as amended from time
                                        to time;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.4 "Charges” </strong>means the price for the
                                        subscription of Cricwick (inclusive of taxes) which
                                        shall automatically be charged to the Customer on daily
                                        basis recursively after the Subscription of the Customer to
                                        the Cricwick in accordance with these Terms and
                                        Conditions and it shall continue to be charged until the
                                        Customer unsubscribed from availing the Cricwick
                                        product;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.5 "Connection”</strong> means Post-paid Connection or
                                        Pre-paid Connection issued by Telenor to the Customers;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.6 "Customer”</strong> means the customer (including
                                        natural or legal person) who is availing Telenor Services
                                        through an MSISDN registered and activated validly in his
                                        name at the time of Subscribing to the Cricwick;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.7 "Encryption”</strong> means any technique used by
                                        Telenor to reasonably secure the data, voice transmission or
                                        other communication over the System including but not
                                        limited to prevent eaves dropping over its
                                        telecommunication system except as required by the law or
                                        beyond its reasonable control;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.8 Data</strong><strong>”</strong> means General
                                        Packet Radio Service or Long Term Evolution Service offered
                                        by Telenor to the Customers;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.9 "License”</strong> means the relevant GSM License
                                        issued to Telenor by PTA for provision of Services in the
                                        Territory;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.10 "Master Blaster League” </strong>means a bundle of
                                        daily tasks for Cricwick subscribers to complete and
                                        earn redeemable points;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.11 "MSISDN Number”</strong> means a unique numerical
                                        number assigned against each Connection for availing Telenor
                                        Services;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.12 "Network”</strong> means Telenor’s GSM network as and
                                        where installed throughout the Territory which is run and
                                        supported by the System;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.13 "Participant”</strong> means the Customer who has
                                        elected to participate in the Campaign as per these Terms
                                        and Conditions;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.14 "Parties” </strong>unless the context provides
                                        otherwise means Telenor and the Participant Customers;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.15 "Payables”</strong> or <strong>“Dues”</strong> mean
                                        any payments due against the Customer for availing Telenor
                                        Services as per the relevant agreement thereof;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                    <strong>2.1.16 "Points” or “Pts” </strong><strong>or</strong><strong>“</strong><strong>Scores</strong><strong>”</strong>                    <strong> </strong>means points earned by the Participant
                                        upon answering a Trivia Question on the Cricwick mobile
                                        app or web. The Points shall be used to rank participants
                                        for the Daily and Weekly Top Scorer Prizes;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                    <strong>2.1.17 "Coins</strong><strong>” or “</strong>                    <strong>Coins</strong><strong>”</strong> means a virtual
                                        currency earned by the Participant by completing the daily
                                        tasks on the Cricwick mobile app or web. The Coins may
                                        be redeemed by the subscribers of Cricwick in the form
                                        of pre-paid Top Ups;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.18 "Wallet” </strong>means the virtual wallet where
                                        a participant’s Daily and Weekly winnings shall be credited
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.19 "Post-paid Connection”</strong> means such
                                        Connection for which the Customer, subject to deposit of
                                        any applicable advance or security, pays for the Telenor
                                        Services after availing the Services;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.20 "Pre-paid Connection”</strong> means such
                                        Connection for which the Customer pays for the Telenor
                                        Services in advance before availing such Services;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.21 "PTA”</strong> means Pakistan Telecommunication
                                        Authority or its successor;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.22 "SIM Card”</strong> means subscriber identity
                                        module card corresponding to the unique MSISDN Number
                                        issued to a Customer;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.23 "SMS” </strong>means the Short Messaging Service
                                        provided by Telenor, but the expression “SMS” used in these
                                        terms and condition shall mean either (i) the SMS sent to
                                        customers and subscribers as invitations and / or service
                                        intimations;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.24 "System”</strong> means Telenor’s GSM mobile cellular
                                        system;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.25 "Taxes” or “t”</strong> include all or any taxes,
                                        levies or fees levied/charged by federal government, any
                                        provincial government or any other lawfully competent
                                        authority;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.26 "Territory”</strong> means the territories for
                                        which Telenor is authorized to provide Services under the
                                        License;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                    <strong>2.1.27 "Value Added Services”</strong> or                    <strong>“VAS”</strong> means any value added services
                                        offered by Telenor from time to time to its Customers;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.28 "Telenor Services”</strong> means the services offered
                                        by Telenor from time to time through the System and Network
                                        including mandatory cellular services and optional services
                                        pursuant to the License; and
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.29 "Telenor”</strong> means Telenor Pakistan Private
                                        Limited. (including its successors and assigns) licensed by
                                        PTA to install and operate the Network throughout the
                                        Territory in order to provide the Services.
                                    </p>
                                </li>
                            </li>
                        </li>
                    </li>
                    <p align="justify">
                        <strong>2.2 </strong>
                        <em><strong>Interpretation</strong></em>
                        <strong>s:</strong>
                    </p>
                    <p lang="en-GB" align="justify">
                    <strong>2.2.1 </strong> Headings are included for convenience only and shall not affect the
                        interpretation hereof. Any reference to the singular shall include the
                        plural and vice versa and any reference to one gender shall include all
                        genders;
                    </p>
                    <p lang="en-GB" align="justify">
                    <strong>2.2.2 </strong> The importance of Clauses shall not be determined by their
                        arrangement/order in these Terms and Conditions;
                    </p>
                    <p lang="en-GB" align="justify">
                    <strong>2.2.3 </strong> The words “include”, “includes”, “including” and “included” will be
                        construed without limitation unless inconsistent with the context; and
                    </p>
                    <p lang="en-GB" align="justify">
                    <strong>2.2.4 </strong> The words not expressly defined herein shall bear the dictionary
                        meanings.
                    </p>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>3 CHANGES IN THE TERMS AND CONDITIONS:</strong>
                            </p>
                        </li>
                    </li>
                    <p align="justify">
                        Telenor maintains the absolute right to amend these Terms and Conditions by
                        publishing the amendments and changes on Cricwick official web site.
                        However, the Customer shall be intimated through an SMS from the Cricwick short code
                        or an SMS from Telenor prior to any such amendment or change taking
                        effect.
                    </p>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>4 SHORT CODES:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                    <a name="_GoBack"></a>
                                    <strong>4.1</strong>  Short Code:
                                </p>
                            </li>
                        </li>
                    </li>
                    <p align="justify">
                        The Cricwick Short Code shall be used for sending invitations to participate in the
                        campaign and/or service intimations by Telenor.
                    </p>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>
                                    5. THE MASTER BLASTER LEAGUE; PRODUCT TERMS AND DETAILS
                                </strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>5.1</strong>  The Master Blaster League is a new product feature being made
                                    available for an introductory launch period and shall be
                                    available to the Customers of Telenor via subscribing to Telenor
                                    Cricket;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>5.2</strong>  The Customer understands, accepts and agrees that the
                                    subscription to Cricwick will result in the free of cost
                                    participation in the Master Blaster League and clicking on the
                                    “Let’s Play” button shall represent an unconditional acceptance
                                    of these Terms and Conditions in their totality whereof the
                                    link shall be sent to the Customer in an SMS;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="3">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>5.3</strong>  The Master Blaster League consists of a list of Daily Tasks
                                    including but not limited to the following:
                                </p>
                            </li>
                        </li>
                    </li>
                    <ul>
                        <li className="mbrules">
                            <p align="justify">
                                Watch videos on Cricwick
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Share a content on their social media
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Share a referral
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Daily come back bonus
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Open Cricwick app for 5 consecutive days
                            </p>
                        </li>
                    </ul>
                    <li className="mbrules">
                        <li start="4">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>5.4</strong>  The Cricwick subscription price is PKR 2.5 plus 19.5% tax, which
                                    shall be charged automatically to the Customer at the start of
                                    each day until such time as the Customer unsubscribes from the
                                    Cricwick platform. When a Customer confirms subscription of
                                    the Cricwick, Customer shall be charged the Charges on a
                                    daily recursive basis in accordance with these Terms and
                                    Conditions. Against such daily Charges the Customer shall avail
                                    all content and features of Cricwick. Customers having
                                    Post-paid connections may use Cricwick or participate in
                                    Master Blaster League, however they are not eligible to claim
                                    any prizes offered in the campaign;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="5">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>5.5</strong>  Customer earning the Coin may redeem them as per the
                                    criteria anytime during the time of his subscription to Telenor
                                    Cricket platform.
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="6">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>5.6</strong>  If any Customer desires to be unregistered as a subscriber of
                                    the Cricwick, he/she shall do it from the Cricwick
                                    mobile app or web;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="7">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>5.7</strong>  If a Customer decides to re-subscribe after unsubscribing from
                                    the Cricwick, he/she can re-subscribe via Cricwick
                                    mobile app or web, and consequently participate in the
                                    Campaign.<strong> </strong>All previously accumulated Points
                                    from the Campaign will also automatically become available for
                                    the re-subscribed Participant if so available for the defined
                                    and relevant period of the Campaign. The re-subscription of a
                                    Customer shall also represent that the Customer has again
                                    unconditionally accepted the Terms and Conditions.
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>6. DETAILS OF CAMPAIGN:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>6.1</strong>  The Customer acknowledges that Telenor has primarily launched this
                                    Campaign to promote Cricwick platform and specifically the
                                    Master Blaster League which has been introduced hereby;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>6.2</strong>  All Customers upon electing to subscribe to the Cricwick by
                                    accepting the Terms and Conditions in the manner prescribed
                                    herein shall become the Participants of the Campaign in in
                                    accordance with these Terms and Conditions;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="3">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>6.3</strong>   To participate in the Campaign, the Customer shall be
                                    registered as a Participant upon the subscription to the Telenor
                                    Cricket consequent to the acceptance of the Terms and
                                    Conditions
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="4">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>6.4</strong>  After registration as a Participant, the Participant shall
                                    become eligible to avail the benefits of the Campaign including
                                    entry in the offered Trivia under the Campaign where the entry
                                    shall be free of cost;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="5">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>6.5</strong>  If a customer fails to pay Cricwick’s subscription charges
                                    i-e PKR 2.5 plus 19.5% tax, for 15 consecutive days, he shall not be
                                    eligible to participate in the Trivia offered under Master
                                    Blaster League
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="6">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>6.6</strong>  The Customer/Participant acknowledges that a number of SMS
                                    and/or in-app notifications for the promotion of the Campaign
                                    and service engagement will be sent throughout the duration of
                                    the Campaign;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>7. DURATION OF THE CAMPAIGN:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>7.1</strong>   The duration of the Campaign shall be till the end of the
                                    specified duration and period of the introductory Master
                    Blaster League as determined by Telenor (the                <strong>“Campaign Period”</strong>);
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>7.2</strong>  Telenor may terminate/discontinue the Campaign at any time during
                                    the Campaign Period; however, the Customer/Participant shall be
                                    intimated in accordance with the applicable laws before the
                                    termination/discontinuation date. After the
                                    termination/discontinuation of the Campaign or expiry of
                                    Campaign Period, Telenor bears no obligation towards the
                                    Customer/Participant without any limitation.
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="3">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>7.3</strong>  In the event that the Customer unregisters his subscription of
                                    the Cricwick during the Campaign Period, the participation
                                    in the Campaign shall also stand suspended however, the
                                    accumulated Points and Coins will be retained and the
                                    Customer will be eligible for prizes if applicable for the
                                    period of participation in the Campaign;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>8. OBLIGATIONS OF CUSTOMER/PARTICIPANT:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>8.1</strong>  The Customer/Participant unconditionally accepts these Terms
                                    and Conditions in addition to the terms and conditions agreed
                                    by the Customer in hard document or electronically for availing
                                    Telenor’s cellular services at the time of getting Connection and
                                    shall absolutely comply with them.
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>8.2</strong>  The Customer/Participant shall refrain from any illegal, unfair
                                    or improper actions/deeds/omissions while subscription of the
                                    Cricwick and participating in the Campaign and for getting
                                    the benefits of the Campaign; and in the event of such an
                                    attempt occurring, Telenor shall have all the rights available to
                                    it under these Terms and Conditions, the agreement executed by
                                    the Customer for availing any of Telenor’s Services and the
                                    applicable laws;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>9. MASTER BLASTER PRIZES AND MECHANICS:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>9.1</strong>  The prizes in Master Blaster League shall be the pre-paid TOP
                                    Up of PKR 50 per redemption and Grand Prize of PKR 100,000 to
                                    be distributed among Top 10 scorers in the Master Blaster
                                    League every month. The distribution will be as follows:
                                </p>
                            </li>
                        </li>
                    </li>
                    <ul>
                        <li>
                            <p align="justify">
                                Winner i-e Top Scorer in the Master Blaster League shall receive
                                PKR 20,000
                            </p>
                        </li>
                        <li>
                            <p align="justify">
                                1<sup>st</sup> &amp; 2<sup>nd</sup> Runners Up shall receive PKR 15,000 each
                            </p>
                        </li>
                        <li>
                            <p align="justify">
                                3<sup>rd</sup>, 4<sup>th</sup> &amp; 5<sup>th</sup> Runners Up shall receive PKR
                                10,000 each
                            </p>
                        </li>
                        <li>
                            <p align="justify">
                                6<sup>th</sup> till 9<sup>th</sup> Runners Up shall receive PKR
                                5,000 each
                            </p>
                        </li>
                    </ul>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>9.2</strong>  If 2 or more participants share the same rank, then the prize
                                    for that rank shall be distributed equally among all
                                    participants sharing that rank.
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                <strong>9.3</strong>  The participant MUST complete the daily tasks to earn Coins,
                                    which thereafter shall be redeemed against the prizes of the
                                    Master Blaster League i-e Top Ups;
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                <strong>9.4</strong>   A customer shall only redeem one TOP Up prize daily;
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                <strong>9.5</strong>   1 Coin will be awarded for every 50 points earned by
                                    completing the daily tasks;
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                <strong>9.6</strong>  1 Coin equals to the value of PKR 1. Hence TOP Up of PKR 50
                                    shall only be redeemed upon earning 50 Coins;
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                <strong>9.7</strong>   Point shall be earned by completing the following tasks but not
                                    limited to:
                                </p>
                            </li>
                        </li>
                    </li>
                    <ul>
                        <li className="mbrules">
                            <p align="justify">
                                For every video content on Cricwick watched for a minimum of 30
                                seconds by a participant shall receive upon fulfilling the criteria
                                20 points. Maximum 3 video views shall be counted for the campaign.
                                A total of 60 points may be earned per day;
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                For every Cricwick video shared on participant’s social media
                                shall receive upon fulfilling the criteria 10 points. The points
                                shall be awarded only once the shared link is being clicked /
                                accessed on social media. The points shall only awarded once the
                                shared link is clicked.
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                For every referral / inviting friends &amp; family on Cricwick
                                shall receive upon fulfilling the criteria 100 points. The points
                                shall be awarded only once the invited referral subscribes to the
                                Cricwick platform;
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                For opening the app every day, the customer shall get the points in
                                the following manner:
                            </p>
                        </li>
                    </ul>
                    <ul>
                        <ul>
                            <li className="mbrules">
                                <p align="justify">
                                    Day1 10 Points
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                    Day 2 20 Points
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                    Day 3 30 Points
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                    Day 4 40 Points
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                    Day 5 50 Points
                                </p>
                            </li>
                        </ul>
                    </ul>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>10. TRIVIA PRIZES AND MECHANICS:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>10.1</strong>  Telenor as a part of the Campaign has introduced Trivia Games (the                <strong>“Trivia”</strong>) which is part of the Campaign;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>10.2</strong>  The Participant of his own free will may elect to participate
                                    in the Trivia;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="3">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>10.3</strong>  The Participant may as part of the Campaign to promote the new
                                    feature of Cricwick i-e Master Blaster League, also play
                                    any of the 3 offered Trivia Gaming formats i-e Tez T20, ODI
                                    &amp; Tuk Tuk Test. The Participant/Customer shall not be
                                    charged anything for participating in the Trivia
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="4">
                            <li className="mbrules">
                                <p align="justify">
                                    <strong>10.4 TEZ T20:</strong>
                                </p>
                            </li>
                        </li>
                    </li>
                    <p align="justify">
                        During the Campaign Period, on every day starting from 00:00:00 and ending
                        on 23:59:59, participants MUST answer 10 questions. Daily cash prize of PR
                        10,000 shall be equally distributed among the Top 150 Participants earning
                        maximum Points by answering the Trivia Questions in TEZ T20.
                    </p>
                    <p align="justify">
                        Only 1 (One) TEZ T20 game may be played in a day.
                    </p>
                    <p align="justify">
                        100 Points shall be awarded for every correct answer during the basic play
                        mode. Whereas 300 points shall be awarded for every correct answer during
                        the Power Play mode. Wrong answers will have ZERO points.
                    </p>
                    <p align="justify">
                        Power Play mode may be offered anytime during the game.
                    </p>
                    <p align="justify">
                        Answers MUST be given within the allotted time
                    </p>
                    <ul>
                        <li className="mbrules">
                            <p align="justify">
                                Time allotted for every questions during Basic Game mode shall be
                                10 seconds
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Time allotted for every questions during Power Play mode shall be 7
                                seconds
                            </p>
                        </li>
                    </ul>
                    <p align="justify">
                        <strong>10.5 ODI</strong>
                    </p>
                    <p align="justify">
                        During the Campaign Period, on every day starting from 00:00:00 and ending
                        on 23:59:59, participants MUST answer 30 questions. Daily cash prize of PR
                        20,000 shall be equally distributed among the Top 200 Participants earning
                        maximum Points by answering the Trivia Questions in ODI.
                    </p>
                    <p align="justify">
                        Only 1 (One) ODI game may be played in a day.
                    </p>
                    <p align="justify">
                        200 Points shall be awarded for every correct answer during the basic play
                        mode. Whereas 400 points shall be awarded for every correct answer during
                        the Power Play mode. Wrong answers will have ZERO points.
                    </p>
                    <p align="justify">
                        Power Play mode may be offered anytime during the game.
                    </p>
                    <p align="justify">
                        Answers MUST be given within the allotted time
                    </p>
                    <ul>
                        <li className="mbrules">
                            <p align="justify">
                                Time allotted for every questions during Basic Game mode shall be
                                15 seconds
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Time allotted for every questions during Power Play mode shall be
                                10 seconds
                            </p>
                        </li>
                    </ul>
                    <p align="justify">
                        <strong>10.6 TUK TUK TEST:</strong>
                    </p>
                    <p align="justify">
                        During the Campaign Period, every week starting from Monday 00:00:00 and
                        ending on Sunday 23:59:59, participants MUST play for at least 3 days and
                        answer 30 questions / day. Weekly cash prize of PR 40,000 shall be equally
                        distributed among the Top 200 Participants earning maximum Points by
                        answering the Trivia Questions in TEST.
                    </p>
                    <p align="justify">
                        A participant may play the TEST game for a maximum of 5 days in a week.
                    </p>
                    <p align="justify">
                        100 Points shall be awarded for every correct answer during the basic play
                        mode. Whereas for every 5 (five) correct answers, a streak shall be
                        activated where participants shall get multiples of basic points. Wrong
                        answers will have ZERO points. Streak shall be discontinued once the
                        customer answers the question incorrectly and the points shall revert to
                        basic points i-e 100 points / correct answer.
                    </p>
                    <p align="justify">
                        Streak point calculation example is as follows:
                    </p>
                    <ul>
                        <li className="mbrules">
                            <p align="justify">
                                Question 1 – Question 5 100 Points / correct answer
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Question 6 – Question 10 200 Points / correct answer
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Question 11 – Question 15 300 Points / correct answer
                            </p>
                        </li>
                    </ul>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>11. POWER PLAY MODE</strong>
                            </p>
                        </li>
                    </li>
                    <p align="justify">
                    During the Campaign Period Telenor shall also announce the bonus schemes (    <strong>“Power Play”</strong>) at various times where the participant
                        receives more points than the ones he/she can receive in the Basic Mode.
                        Power Play shall only be offered during TEZ T20 &amp; ODI gaming formats.
                        Time allotted to answer questions during Power Play will be less than the
                        Basic Game mode.
                    </p>
                    <p align="justify">
                        There shall be no Power Play mode in TUK TUK TEST gaming format.
                    </p>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>12. CONDITIONS TO WIN AND RECEIVE THE PRIZES</strong>
                            </p>
                        </li>
                    </li>
                    <p align="justify">
                        <strong>12.1</strong>  The Daily Prize, Weekly Prize, Monthly Grand Prize and TOP Ups shall
                        collectively be referred to as the “Prizes” and separately as the “Prize”;
                    </p>
                    <p align="justify">
                        <strong>12.2</strong>  All cash prizes shall be disbursed to the customer via Jazz Cash or
                        Easy Paisa. A participant must provide his Jazz Cash or Easy Paisa account
                        details to claim the prize;
                    </p>
                    <p align="justify">
                        <strong>12.3</strong>  All Prizes will be subject to applicable Taxes before being handed
                        over to the winning Participant;
                    </p>
                    <p align="justify">
                        <strong>12.4</strong>  Daily &amp; weekly cash winning shall be credited to the participant’s
                        virtual Cricwick Wallet. However, a participant may claim the prize
                        money once his wallet balance touches PKR 1,000;
                    </p>
                    <p align="justify">
                        <strong>12.5</strong>  Cash prizes shall only be disbursed into participant’s designated Jazz
                        Cash or easy Paisa account;
                    </p>
                    <p align="justify">
                        <strong>12.6</strong>  The Participants shall be able to win one type of the Prize once only
                        except the TOP Up which can be redeemed multiple times. The Types of Prizes
                        are given below:
                    </p>
                    <ul >
                        <li className="mbrules">
                            <p align="justify">
                                Daily Prize
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Weekly Prize
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Monthly Grand Prize
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Redeemable TOP Ups
                            </p>
                        </li>
                    </ul>
                    <p align="justify">
                        <strong>12.5 </strong> The Prize Winning Participant shall be required to produce his
                        original CNIC for verification of his antecedents from Telenor’s records and
                        after verification such Participant shall be given the Prize;
                    </p>
                    <p align="justify">
                        <strong>12.6 </strong> If the winning Participant is under 18, then the prize will be awarded
                        to the person whose name the SIM is registered and the prize will be handed
                        over only after verification in accordance with clause <strong>12.5;</strong> 
                    </p>
                    <p align="justify">
                        <strong>12.7 </strong> Telenor reserves the right to disqualify any Participant from receiving
                        any prize(s) if it has reasonable grounds to believe that the Participant
                        breached any provision of the Terms and Conditions and/or the agreement
                        executed for availing Telenor Services;
                    </p>
                    <p align="justify">
                        <strong>12.8 </strong> The Prize winning Participant shall be contacted by Telenor and such
                        Participant shall undertake in writing that he is, the lawful owner of the
                        SIM and MSISDN (cell number), is entitled to receive the Prize and in case
                        of any claimant disputing the receiving of such Prize he shall be
                        responsible for the settlement of such dispute and shall indemnify Telenor in
                        full regarding such dispute (including but not limited to all cost,
                        expenses and reasonable attorney fees incurred by Telenor in relation
                        thereto);
                    </p>
                    <p align="justify">
                        <strong>12.9 </strong> The Prize Winning Participant shall provide all the documents required
                        by Telenor including a Disclaimer stating that he is not disqualified under
                        Clause 13.14 to participate in the Campaign;
                    </p>
                    <p align="justify">
                        <strong>12.10</strong>  The Participant agrees that Telenor may use such photographs, videos and
                        audio recordings taken at the time of Prize distribution, communication
                        happened/exchanged during contact by Telenor for intimation of prize winning
                        and other information including names, surnames etc., in Telenor’s
                        advertisements of the Campaign without any further/prior/specific consent
                        for such purpose. The consent given here and the incorporation of any
                        contents/information in the advertisement of the Campaign shall not entitle
                        the Participant for any remuneration/amount in any manner. If a winning
                        participant later becomes disqualified under these Terms and Conditions to
                        receive the Prize, then any release of advertisement about his winning
                        shall not create any obligation/responsibility on Telenor in favor of such
                        participant either related to the Prize or to any social, financial or
                        other exposure in this regard;
                    </p>
                    <p align="justify">
                        <strong>12.11</strong>  If the notified winner Participant cannot be reached / contacted,
                        disqualified or refuses the Prize or fails to appear to collect it within
                        20 calendar days (the <strong>“Grace Period”</strong>) after the campaign
                        ends, then the claim from winning Participant/runner up shall not be
                        entertained without regard to the reason of such delay/lapse;
                    </p>
                    <p align="justify">
                        <strong>12.12</strong>  The cash Prize Winning Participant must have Jazz Cash or Easy Paisa
                        Account in order to receive the Prize. In case the winner does not have an
                        existing Account, he will be given a period of 15 working days to open Telenor
                        Cash or Easy Paisa account and revert back to Telenor. In case he does not
                        revert back to Telenor in the prescribed time period of 20 days after the
                        campaign ends, it shall be considered the lapse of Grace Period and such
                        Participant shall face the consequences of lapse of Grace Period;
                    </p>
                    <p align="justify">
                        <strong>12.13</strong>  The Prize winner cannot assign or transfer the Prize;
                    </p>
                    <p align="justify">
                        <strong>12.14</strong>  The Participant agrees that Telenor shall not be responsible/liable for
                        any loss, injuries or damages of any kind caused to the Participant by or
                        resulting from the Campaign, the participation in the Campaign, acceptance
                        or receiving the Prizes, or disqualification to receive any Prize including
                        without limitation on account of lapse of Grace Period;
                    </p>
                    <p align="justify">
                        <strong>12.15</strong>  Telenor reserves the right to stop (Pre-mature Stoppage) the Campaign
                        prior to its last date due to any reasons, including but not limited to as
                        mentioned in clause 13.10 herein. In case of Pre-Mature Stoppage, Telenor will
                        publish the results of the Campaign at T&amp;C Link
                        http://cricwick.net/_____________ and shall only give out the prizes
                        won up to the date of Pre-Mature Stoppage;
                    </p>
                    <p align="justify">
                        <strong>12.16</strong>  The Participant understands, agrees and accepts that the decisions
                        made by Telenor shall be final and binding on him.
                    </p>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>13. MISCELLANEOUS:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.1</strong>  Telenor shall not have any liabilities towards the
                                    Customer/Participant after the expiry of Campaign Period except
                                    provided otherwise expressly in the Terms and Conditions. JC
                                    Coins earned during the campaign may be redeemed anytime as
                                    long as the customer stays subscribed to Cricwick.
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.2</strong>  Telenor shall not be responsible for any loss or damage resulting
                                    to the Participant or any third party in any manner in
                                    association and/or connection with the Campaign and
                                    participation therein;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="3">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.3</strong>  Telenor undertakes/gives no warranty (whether express or implied)
                                    whatsoever with respect to the entitlement for any Prize by
                                    mere participation of Participant in the Campaign;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="4">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.4</strong>  Fraud or abuse relating to accrual of Points, may result in
                                    forfeiture/cancellation of such accrued Points as well as
                                    cancellation of a Participant’s eligibility for the Campaign,
                                    suspension of Telenor’s Services to the Participant and
                                    termination of Participant’s Telenor connection; and any decision
                                    by Telenor in this respect shall be final;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="5">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.5</strong>  Without prejudice to Clause 13.4, all questions or disputes
                                    regarding eligibility of the Participant for the Campaign, the
                                    accrual/accumulation of Points and giving of Prizes shall be
                                    resolved by Telenor in its sole discretion and any decision by
                                    Telenor in this respect shall be final;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="6">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.6</strong>  Telenor’s failure or delay to enforce a particular term and
                                    condition, right, remedy or penalty shall not constitute as a
                                    waiver of that term and condition, remedy, penalty by Telenor.
                                    Further the enforcement of these Terms and Conditions, right,
                                    remedy or penalty shall not mean the waiver of other terms,
                                    remedies or penalties available to Telenor under this document,
                                    other applicable documents/agreements between Telenor and the
                                    Participant and the relevant laws;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="7">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.7</strong>  Telenor reserves the right to disqualify any Participant from
                                    further participation in the Campaign, if it has reason to
                                    believe that the Participant has in any way violated these
                                    Terms and Conditions, or the terms and conditions of the
                                    agreement executed for availing Telenor Services (which is
                                    mandatory to execute before availing Telenor Services). If a
                                    Participant is availing Telenor Services without execution of any
                                    agreement in this regard, it shall be presumed a breach of
                                    these Terms and Conditions in itself;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="8">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.8</strong>  Unless otherwise expressly stated or implied by context, each
                                    of the Terms and Conditions herein contained shall be severable
                                    and distinct from one another and if any provision of these
                                    Terms and Conditions is held to be invalid, illegal or
                                    unenforceable by a court of competent jurisdiction or any
                                    competent authority, such invalidity, illegality or
                                    unenforceability shall not affect the validity, legality and
                                    enforceability of the remaining provisions. In case any
                                    provision is held to be invalid, illegal or unenforceable by a
                                    competent authority or court, Telenor shall have the right to
                                    amend these Terms and Conditions as may be required as a result
                                    of the order of the competent court or authority. However, in
                                    case the remaining Terms and Conditions cannot survive pursuant
                                    to the order of the competent authority or court, or the
                                    amendment renders these Terms &amp; Condition incapable of
                                    being performed to the extent of obligations with regards to a
                                    Participant/Prize winner, the Participant/Prize winner
                                    understands, accepts and agrees that Telenor in such circumstances
                                    shall have the right to terminate the agreement concluded
                                    between Telenor and the Participant hereby;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="9">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.9</strong>  If a Force Majeure event occurs that directly affects the
                                    ability of Telenor to perform its obligations hereunder, Telenor
                                    shall be entitled to suspend performance of such an obligation
                                    for the duration of the Force Majeure event. Force Majeure
                                    includes acts of God, war, hostilities, riots, civil commotion,
                                    strike, revolution, epidemic, accident, fire, flood,
                                    earthquake, blockade, any decision of the court, tribunal or
                                    authority, PTA or any other cause similar to the kind herein
                                    enumerated or of equivalent force not within the control of
                                    Telenor (including but not limited to reasons attributable to
                                    failure of machinery, Telenor’s telecommunication system, any
                                    hardware or software);
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="10">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.10</strong>  The decision of Telenor in respect of any dispute that may arise
                                    in connection with these Terms and Conditions shall be final
                                    and binding on the Participant;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="11">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.11</strong>  The Customer/Participant acknowledges that under this Campaign
                                    he shall not respond to any calls/SMSs directing to make/send
                                    calls/SMSs to any other number/short code or which are
                                    regarding award of any prize (whether money or in kind) in lieu
                                    of balance transfer or any call. Ignorance of this clause by
                                    the Customer shall not accrue any liabilities/responsibilities
                                    on Telenor including but not limited to liability/responsibility
                                    towards any loss occurred to the Customer/Participant;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="12">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.12</strong>  The language of the Campaign shall be Roman Urdu and/or
                                    English;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="13">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.13</strong>  The Customer who has executed the agreement for availing Telenor
                                    Services against the MSISDN (cell number) under his use shall
                                    be eligible to participate in the Campaign and not otherwise.
                                    However, notwithstanding anything contained herein, the
                                    following shall not be eligible to participate in the Campaign:
                                </p>
                            </li>
                        </li>
                    </li>
                    <li>
                        <li className="mbrules">
                            <p align="justify">
                                The employees of Telenor;
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Telenor Franchises and Retailers and the employees of its sister
                                concerns;
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                    The spouse, children, parents and siblings (            <strong>“First Degree Relatives”</strong>) of Telenor employees;
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                The registered users of Telenor employee family number; and
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                The contractors, technical service providers and/or professionals
                                and their employees working for this Campaign.
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>
                                    14. COMPLAINT/QUERY HANDLING, DISPUTE RESOLUTION AND ARBITRATION:
                                </strong>
                            </p>
                        </li>
                    </li>
                    <p align="justify">
                        <b>  14.1</b>  The Participant can call at the helpline by dialing 300 round the
                        clock for any complaints regarding the Campaign. The Participant’s call
                        shall be recorded against his CLI for record keeping and in accordance with
                        the instructions given by PTA. Prescribed tariff rates shall be charged for
                        using the helpline services;
                    </p>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <b>14.2</b>  If a Participant requires information regarding the Campaign or
                                    the Trivia, he can access FAQ, Game Rules &amp; detailed
                                    T&amp;C available on Cricwick mobile app and web;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <b>14.3</b>  A Participant can check his rank by accessing the leaderboard
                                    available on the Cricwick mobile app and web;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="3">
                            <li className="mbrules">
                                <p align="justify">
                                <b>14.4</b>  The Campaign and/or the Trivia and these Terms and Conditions
                                    shall be governed by the laws of Pakistan and interpreted in
                                    accordance with laws of Pakistan. If the Participant shall be
                                    of the opinion that he has any right pertaining to the Campaign
                                    and he wishes to invoke such right, the Participant
                                    acknowledges, understands and agrees that such right can only
                                    be invoked through the arbitration which shall be conducted by
                                    the sole arbitrator appointed by Telenor and such arbitration
                                    proceedings shall be conducted in English or Urdu language at
                                    Lahore under the Arbitration Act 1940. Without prejudice to the
                                    above, it is further agreed by the Participant that only the
                                    courts at Lahore shall have the jurisdiction on any matter
                                    relating to the Campaign.
                                </p>
                            </li>
                        </li>
                    </li>

                </div>
            )
        } else if (operatorName === "zong") { //Zong
            return (
                <div style={{ fontSize: '14px' }} className="px-3 info">
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>1. INTRODUCTION:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <b>1.1</b>  China Mobile Pakistan (henceforth                <strong>Zong</strong>) provides telecommunication services in
                    the Islamic Republic of Pakistan, AJK and Gilgit Baltistan (the                <strong>“Territory”</strong>). Zong is offering various value
                    added services <strong>(“VAS”) </strong>which also<strong> </strong>includes short messaging service (                <strong>“SMS”</strong>);
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <b>1.2</b>  A new feature (the                <strong>“Master Blaster League”</strong>) is being introduced in Cricwick 
                                    “The VAS product”. The Master Blaster League in its introductory
                                    launch period shall be available for a period of 90 days and
                                    may be extended thereafter. The participation in Master Blaster
                                    League is subject to the successful subscription of Cricwick
                                    at PKR 7 plus tax (Govt. tax of 19.5% is applicable) per week (defined as                <strong>“Charges”</strong> below);
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="3">
                            <li className="mbrules">
                                <p align="justify">
                                <b>1.3</b>  Zong is launching a specially designed marketing campaign                <strong>(</strong>the <strong>“Campaign”) </strong>to promote
                                    its VAS Product “Cricwick” and its newly introduced feature
                                    “Master Blaster League”<strong>. </strong>The Campaign includes
                                    incentives for the Customers subscribing to the Cricwick
                                    and engaging in with the Daily Tasks on the platform, including
                                    the free of cost participation in the Trivia and win a wide
                                    array of cash prizes detailed hereunder. The duration of the
                                    Campaign shall be the introductory period of the Master Blaster
                                    League (i.e. 90 days). Zong has created a webpage
                    http://cricwick.net/_________ (                <strong>“T&amp;C Link”</strong>) and made these Terms and
                                    Conditions (as defined below) available on the Cricwick
                                    mobile app to provide detailed information pertaining to the
                                    Campaign. The Website is publically accessible, whereas the
                                    mobile app shall be accessible to Cricwick subscribers
                                    only;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="4">
                            <li className="mbrules">
                                <p align="justify">
                                <b>1.4</b>  The terms and conditions mentioned herein (                <strong>“Terms and Conditions”</strong>) shall determine the
                                    rights and liabilities of Zong and the Customer (as defined
                                    below) regarding the Cricwick subscription and also the
                                    Campaign. In order to purchase the subscription to the Zong
                                    Cricket and consequently also to participate in the Campaign,
                                    the Customer shall accept these Terms and Conditions in their
                                    totality by clicking on the <strong>“Let’s Start”</strong>
                                    button on the Cricwick mobile app and web page. The click
                                    on the button therein, would be for all intents and purposes be
                                    deemed as acceptance on the part of the Customer with these
                                    Terms and Conditions in their totality. The sole consideration
                                    granting the Customer the right to participate in the Campaign
                                    is the subscription to the Cricwick.
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>2. DEFINITIONS AND INTERPRETATIONS:</strong>
                            </p>
                        </li>
                    </li>
                    <p align="justify">
                        <strong>2.1 </strong>
                        <em><strong>Definitions:</strong></em>
                    </p>
                    <p lang="x-none" align="justify">
                        Unless the context requires otherwise, the expressions used in these Terms
                        and Conditions and not defined elsewhere in such Terms and Condition shall
                        have the following meanings assigned to them:
                    </p>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                    <strong>2.1.1 "Advertisement”</strong> or                    <strong>“Advertised by Zong”</strong> means publication or
                                        advertisement of any information, policy, notice,
                                        intimation, public message or any other communication
                                        regarding the Campaign, collectively or separately, through
                                        any medium including but not limited to digital,
                                        television, radio, outdoor, hoardings/billboards, internet,
                                        cellular and/or print media, SMS Broadcast etc.;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.2 "Terms and Conditions” </strong>means these terms
                                        and conditions;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.3 "Approved modes of communication”</strong> means
                                        any of the modes of communication provided in Telecom
                                        Consumer Protection Regulations, 2009 as amended from time
                                        to time;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.4 "Charges” </strong>means the price for the
                                        subscription of Cricwick (inclusive of taxes) which
                                        shall automatically be charged to the Customer on daily
                                        basis recursively after the Subscription of the Customer to
                                        the Cricwick in accordance with these Terms and
                                        Conditions and it shall continue to be charged until the
                                        Customer unsubscribed from availing the Cricwick
                                        product;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.5 "Connection”</strong> means Post-paid Connection or
                                        Pre-paid Connection issued by Zong to the Customers;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.6 "Customer”</strong> means the customer (including
                                        natural or legal person) who is availing Zong Services
                                        through an MSISDN registered and activated validly in his
                                        name at the time of Subscribing to the Cricwick;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.7 "Encryption”</strong> means any technique used by
                                        Zong to reasonably secure the data, voice transmission or
                                        other communication over the System including but not
                                        limited to prevent eaves dropping over its
                                        telecommunication system except as required by the law or
                                        beyond its reasonable control;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.8 Data</strong><strong>”</strong> means General
                                        Packet Radio Service or Long Term Evolution Service offered
                                        by Zong to the Customers;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.9 "License”</strong> means the relevant GSM License
                                        issued to Zong by PTA for provision of Services in the
                                        Territory;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.10 "Master Blaster League” </strong>means a bundle of
                                        daily tasks for Cricwick subscribers to complete and
                                        earn redeemable points;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.11 "MSISDN Number”</strong> means a unique numerical
                                        number assigned against each Connection for availing Zong
                                        Services;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.12 "Network”</strong> means Zong’s GSM network as and
                                        where installed throughout the Territory which is run and
                                        supported by the System;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.13 "Participant”</strong> means the Customer who has
                                        elected to participate in the Campaign as per these Terms
                                        and Conditions;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.14 "Parties” </strong>unless the context provides
                                        otherwise means Zong and the Participant Customers;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.15 "Payables”</strong> or <strong>“Dues”</strong> mean
                                        any payments due against the Customer for availing Zong
                                        Services as per the relevant agreement thereof;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                    <strong>2.1.16 "Points” or “Pts” </strong><strong>or</strong><strong>“</strong><strong>Scores</strong><strong>”</strong>                    <strong> </strong>means points earned by the Participant
                                        upon answering a Trivia Question on the Cricwick mobile
                                        app or web. The Points shall be used to rank participants
                                        for the Daily and Weekly Top Scorer Prizes;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                    <strong>2.1.17 "Coins</strong><strong>” or “</strong>                    <strong>Coins</strong><strong>”</strong> means a virtual
                                        currency earned by the Participant by completing the daily
                                        tasks on the Cricwick mobile app or web. The Coins may
                                        be redeemed by the subscribers of Cricwick in the form
                                        of pre-paid Top Ups;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.18 "Wallet” </strong>means the virtual wallet where
                                        a participant’s Daily and Weekly winnings shall be credited
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.19 "Post-paid Connection”</strong> means such
                                        Connection for which the Customer, subject to deposit of
                                        any applicable advance or security, pays for the Zong
                                        Services after availing the Services;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.20 "Pre-paid Connection”</strong> means such
                                        Connection for which the Customer pays for the Zong
                                        Services in advance before availing such Services;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.21 "PTA”</strong> means Pakistan Telecommunication
                                        Authority or its successor;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.22 "SIM Card”</strong> means subscriber identity
                                        module card corresponding to the unique MSISDN Number
                                        issued to a Customer;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.23 "SMS” </strong>means the Short Messaging Service
                                        provided by Zong, but the expression “SMS” used in these
                                        terms and condition shall mean either (i) the SMS sent to
                                        customers and subscribers as invitations and / or service
                                        intimations;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.24 "System”</strong> means Zong’s GSM mobile cellular
                                        system;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.25 "Taxes” or “t”</strong> include all or any taxes,
                                        levies or fees levied/charged by federal government, any
                                        provincial government or any other lawfully competent
                                        authority;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.26 "Territory”</strong> means the territories for
                                        which Zong is authorized to provide Services under the
                                        License;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                    <strong>2.1.27 "Value Added Services”</strong> or                    <strong>“VAS”</strong> means any value added services
                                        offered by Zong from time to time to its Customers;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.28 "Zong Services”</strong> means the services offered
                                        by Zong from time to time through the System and Network
                                        including mandatory cellular services and optional services
                                        pursuant to the License; and
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.29 "Zong”</strong> means China Mobile Pakistan. 
                                        (including its successors and assigns) licensed by
                                        PTA to install and operate the Network throughout the
                                        Territory in order to provide the Services.
                                    </p>
                                </li>
                            </li>
                        </li>
                    </li>
                    <p align="justify">
                        <strong>2.2 </strong>
                        <em><strong>Interpretation</strong></em>
                        <strong>s:</strong>
                    </p>
                    <p lang="en-GB" align="justify">
                    <strong>2.2.1 </strong> Headings are included for convenience only and shall not affect the
                        interpretation hereof. Any reference to the singular shall include the
                        plural and vice versa and any reference to one gender shall include all
                        genders;
                    </p>
                    <p lang="en-GB" align="justify">
                    <strong>2.2.2 </strong> The importance of Clauses shall not be determined by their
                        arrangement/order in these Terms and Conditions;
                    </p>
                    <p lang="en-GB" align="justify">
                    <strong>2.2.3 </strong> The words “include”, “includes”, “including” and “included” will be
                        construed without limitation unless inconsistent with the context; and
                    </p>
                    <p lang="en-GB" align="justify">
                    <strong>2.2.4 </strong> The words not expressly defined herein shall bear the dictionary
                        meanings.
                    </p>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>3 CHANGES IN THE TERMS AND CONDITIONS:</strong>
                            </p>
                        </li>
                    </li>
                    <p align="justify">
                        Zong maintains the absolute right to amend these Terms and Conditions by
                        publishing the amendments and changes on Cricwick official web site.
                        However, the Customer shall be intimated through an SMS from the Cricwick short code
                        or an SMS from Zong prior to any such amendment or change taking
                        effect.
                    </p>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>4 SHORT CODES:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                    <a name="_GoBack"></a>
                                    <strong>4.1</strong>  Short Code:
                                </p>
                            </li>
                        </li>
                    </li>
                    <p align="justify">
                        The Cricwick Short Code shall be used for sending invitations to participate in the
                        campaign and/or service intimations by Zong.
                    </p>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>
                                    5. THE MASTER BLASTER LEAGUE; PRODUCT TERMS AND DETAILS
                                </strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>5.1</strong>  The Master Blaster League is a new product feature being made
                                    available for an introductory launch period and shall be
                                    available to the Customers of Zong via subscribing to Zong
                                    Cricket;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>5.2</strong>  The Customer understands, accepts and agrees that the
                                    subscription to Cricwick will result in the free of cost
                                    participation in the Master Blaster League and clicking on the
                                    “Let’s Play” button shall represent an unconditional acceptance
                                    of these Terms and Conditions in their totality whereof the
                                    link shall be sent to the Customer in an SMS;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="3">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>5.3</strong>  The Master Blaster League consists of a list of Daily Tasks
                                    including but not limited to the following:
                                </p>
                            </li>
                        </li>
                    </li>
                    <ul>
                        <li className="mbrules">
                            <p align="justify">
                                Watch videos on Cricwick
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Share a content on their social media
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Share a referral
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Daily come back bonus
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Open Cricwick app for 5 consecutive days
                            </p>
                        </li>
                    </ul>
                    <li className="mbrules">
                        <li start="4">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>5.4</strong>  The Cricwick subscription price is PKR 7 plus 19.5% tax per week, which
                                    shall be charged automatically to the Customer at the start of
                                    each week until such time as the Customer unsubscribes from the
                                    Cricwick platform. When a Customer confirms subscription of
                                    the Cricwick, Customer shall be charged the Charges on a
                                    daily recursive basis in accordance with these Terms and
                                    Conditions. Against such daily Charges the Customer shall avail
                                    all content and features of Cricwick. Customers having
                                    Post-paid connections may use Cricwick or participate in
                                    Master Blaster League, however they are not eligible to claim
                                    any prizes offered in the campaign;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="5">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>5.5</strong>  Customer earning the Coin may redeem them as per the
                                    criteria anytime during the time of his subscription to Zong
                                    Cricket platform.
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="6">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>5.6</strong>  If any Customer desires to be unregistered as a subscriber of
                                    the Cricwick, he/she shall do it from the Cricwick
                                    mobile app or web;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="7">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>5.7</strong>  If a Customer decides to re-subscribe after unsubscribing from
                                    the Cricwick, he/she can re-subscribe via Cricwick
                                    mobile app or web, and consequently participate in the
                                    Campaign.<strong> </strong>All previously accumulated Points
                                    from the Campaign will also automatically become available for
                                    the re-subscribed Participant if so available for the defined
                                    and relevant period of the Campaign. The re-subscription of a
                                    Customer shall also represent that the Customer has again
                                    unconditionally accepted the Terms and Conditions.
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>6. DETAILS OF CAMPAIGN:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>6.1</strong>  The Customer acknowledges that Zong has primarily launched this
                                    Campaign to promote Cricwick platform and specifically the
                                    Master Blaster League which has been introduced hereby;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>6.2</strong>  All Customers upon electing to subscribe to the Cricwick by
                                    accepting the Terms and Conditions in the manner prescribed
                                    herein shall become the Participants of the Campaign in in
                                    accordance with these Terms and Conditions;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="3">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>6.3</strong>   To participate in the Campaign, the Customer shall be
                                    registered as a Participant upon the subscription to the Zong
                                    Cricket consequent to the acceptance of the Terms and
                                    Conditions
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="4">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>6.4</strong>  After registration as a Participant, the Participant shall
                                    become eligible to avail the benefits of the Campaign including
                                    entry in the offered Trivia under the Campaign where the entry
                                    shall be free of cost;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="5">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>6.5</strong>  If a customer fails to pay Cricwick’s subscription charges
                                    i-e PKR 7 plus 19.5% tax per week, for 2 consecutive weeks, he shall not be
                                    eligible to participate in the Trivia offered under Master
                                    Blaster League
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="6">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>6.6</strong>  The Customer/Participant acknowledges that a number of SMS
                                    and/or in-app notifications for the promotion of the Campaign
                                    and service engagement will be sent throughout the duration of
                                    the Campaign;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>7. DURATION OF THE CAMPAIGN:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>7.1</strong>   The duration of the Campaign shall be till the end of the
                                    specified duration and period of the introductory Master
                    Blaster League as determined by Zong (the                <strong>“Campaign Period”</strong>);
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>7.2</strong>  Zong may terminate/discontinue the Campaign at any time during
                                    the Campaign Period; however, the Customer/Participant shall be
                                    intimated in accordance with the applicable laws before the
                                    termination/discontinuation date. After the
                                    termination/discontinuation of the Campaign or expiry of
                                    Campaign Period, Zong bears no obligation towards the
                                    Customer/Participant without any limitation.
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="3">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>7.3</strong>  In the event that the Customer unregisters his subscription of
                                    the Cricwick during the Campaign Period, the participation
                                    in the Campaign shall also stand suspended however, the
                                    accumulated Points and Coins will be retained and the
                                    Customer will be eligible for prizes if applicable for the
                                    period of participation in the Campaign;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>8. OBLIGATIONS OF CUSTOMER/PARTICIPANT:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>8.1</strong>  The Customer/Participant unconditionally accepts these Terms
                                    and Conditions in addition to the terms and conditions agreed
                                    by the Customer in hard document or electronically for availing
                                    Zong’s cellular services at the time of getting Connection and
                                    shall absolutely comply with them.
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>8.2</strong>  The Customer/Participant shall refrain from any illegal, unfair
                                    or improper actions/deeds/omissions while subscription of the
                                    Cricwick and participating in the Campaign and for getting
                                    the benefits of the Campaign; and in the event of such an
                                    attempt occurring, Zong shall have all the rights available to
                                    it under these Terms and Conditions, the agreement executed by
                                    the Customer for availing any of Zong’s Services and the
                                    applicable laws;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>9. MASTER BLASTER PRIZES AND MECHANICS:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>9.1</strong>  The prizes in Master Blaster League shall be the pre-paid TOP
                                    Up of PKR 50 per redemption and Grand Prize of PKR 100,000 to
                                    be distributed among Top 10 scorers in the Master Blaster
                                    League every month. The distribution will be as follows:
                                </p>
                            </li>
                        </li>
                    </li>
                    <ul>
                        <li>
                            <p align="justify">
                                Winner i-e Top Scorer in the Master Blaster League shall receive
                                PKR 20,000
                            </p>
                        </li>
                        <li>
                            <p align="justify">
                                1<sup>st</sup> &amp; 2<sup>nd</sup> Runners Up shall receive PKR 15,000 each
                            </p>
                        </li>
                        <li>
                            <p align="justify">
                                3<sup>rd</sup>, 4<sup>th</sup> &amp; 5<sup>th</sup> Runners Up shall receive PKR
                                10,000 each
                            </p>
                        </li>
                        <li>
                            <p align="justify">
                                6<sup>th</sup> till 9<sup>th</sup> Runners Up shall receive PKR
                                5,000 each
                            </p>
                        </li>
                    </ul>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>9.2</strong>  If 2 or more participants share the same rank, then the prize
                                    for that rank shall be distributed equally among all
                                    participants sharing that rank.
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                <strong>9.3</strong>  The participant MUST complete the daily tasks to earn Coins,
                                    which thereafter shall be redeemed against the prizes of the
                                    Master Blaster League i-e Top Ups;
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                <strong>9.4</strong>   A customer shall only redeem one TOP Up prize daily;
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                <strong>9.5</strong>   1 Coin will be awarded for every 50 points earned by
                                    completing the daily tasks;
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                <strong>9.6</strong>  1 Coin equals to the value of PKR 1. Hence TOP Up of PKR 50
                                    shall only be redeemed upon earning 50 Coins;
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                <strong>9.7</strong>   Point shall be earned by completing the following tasks but not
                                    limited to:
                                </p>
                            </li>
                        </li>
                    </li>
                    <ul>
                        <li className="mbrules">
                            <p align="justify">
                                For every video content on Cricwick watched for a minimum of 30
                                seconds by a participant shall receive upon fulfilling the criteria
                                20 points. Maximum 3 video views shall be counted for the campaign.
                                A total of 60 points may be earned per day;
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                For every Cricwick video shared on participant’s social media
                                shall receive upon fulfilling the criteria 10 points. The points
                                shall be awarded only once the shared link is being clicked /
                                accessed on social media. The points shall only awarded once the
                                shared link is clicked.
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                For every referral / inviting friends &amp; family on Cricwick
                                shall receive upon fulfilling the criteria 100 points. The points
                                shall be awarded only once the invited referral subscribes to the
                                Cricwick platform;
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                For opening the app every day, the customer shall get the points in
                                the following manner:
                            </p>
                        </li>
                    </ul>
                    <ul>
                        <ul>
                            <li className="mbrules">
                                <p align="justify">
                                    Day1 10 Points
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                    Day 2 20 Points
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                    Day 3 30 Points
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                    Day 4 40 Points
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                    Day 5 50 Points
                                </p>
                            </li>
                        </ul>
                    </ul>
                    <li  className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>10. TRIVIA PRIZES AND MECHANICS:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>10.1</strong>  Zong as a part of the Campaign has introduced Trivia Games (the                <strong>“Trivia”</strong>) which is part of the Campaign;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>10.2</strong>  The Participant of his own free will may elect to participate
                                    in the Trivia;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="3">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>10.3</strong>  The Participant may as part of the Campaign to promote the new
                                    feature of Cricwick i-e Master Blaster League, also play
                                    any of the 3 offered Trivia Gaming formats i-e Tez T20, ODI
                                    &amp; Tuk Tuk Test. The Participant/Customer shall not be
                                    charged anything for participating in the Trivia
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="4">
                            <li className="mbrules">
                                <p align="justify">
                                    <strong>10.4 TEZ T20:</strong>
                                </p>
                            </li>
                        </li>
                    </li>
                    <p align="justify">
                        During the Campaign Period, on every day starting from 00:00:00 and ending
                        on 23:59:59, participants MUST answer 10 questions. Daily cash prize of PR
                        10,000 shall be equally distributed among the Top 150 Participants earning
                        maximum Points by answering the Trivia Questions in TEZ T20.
                    </p>
                    <p align="justify">
                        Only 1 (One) TEZ T20 game may be played in a day.
                    </p>
                    <p align="justify">
                        100 Points shall be awarded for every correct answer during the basic play
                        mode. Whereas 300 points shall be awarded for every correct answer during
                        the Power Play mode. Wrong answers will have ZERO points.
                    </p>
                    <p align="justify">
                        Power Play mode may be offered anytime during the game.
                    </p>
                    <p align="justify">
                        Answers MUST be given within the allotted time
                    </p>
                    <ul>
                        <li className="mbrules">
                            <p align="justify">
                                Time allotted for every questions during Basic Game mode shall be
                                10 seconds
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Time allotted for every questions during Power Play mode shall be 7
                                seconds
                            </p>
                        </li>
                    </ul>
                    <p align="justify">
                        <strong>10.5 ODI</strong>
                    </p>
                    <p align="justify">
                        During the Campaign Period, on every day starting from 00:00:00 and ending
                        on 23:59:59, participants MUST answer 30 questions. Daily cash prize of PR
                        20,000 shall be equally distributed among the Top 200 Participants earning
                        maximum Points by answering the Trivia Questions in ODI.
                    </p>
                    <p align="justify">
                        Only 1 (One) ODI game may be played in a day.
                    </p>
                    <p align="justify">
                        200 Points shall be awarded for every correct answer during the basic play
                        mode. Whereas 400 points shall be awarded for every correct answer during
                        the Power Play mode. Wrong answers will have ZERO points.
                    </p>
                    <p align="justify">
                        Power Play mode may be offered anytime during the game.
                    </p>
                    <p align="justify">
                        Answers MUST be given within the allotted time
                    </p>
                    <ul>
                        <li className="mbrules">
                            <p align="justify">
                                Time allotted for every questions during Basic Game mode shall be
                                15 seconds
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Time allotted for every questions during Power Play mode shall be
                                10 seconds
                            </p>
                        </li>
                    </ul>
                    <p align="justify">
                        <strong>10.6 TUK TUK TEST:</strong>
                    </p>
                    <p align="justify">
                        During the Campaign Period, every week starting from Monday 00:00:00 and
                        ending on Sunday 23:59:59, participants MUST play for at least 3 days and
                        answer 30 questions / day. Weekly cash prize of PR 40,000 shall be equally
                        distributed among the Top 200 Participants earning maximum Points by
                        answering the Trivia Questions in TEST.
                    </p>
                    <p align="justify">
                        A participant may play the TEST game for a maximum of 5 days in a week.
                    </p>
                    <p align="justify">
                        100 Points shall be awarded for every correct answer during the basic play
                        mode. Whereas for every 5 (five) correct answers, a streak shall be
                        activated where participants shall get multiples of basic points. Wrong
                        answers will have ZERO points. Streak shall be discontinued once the
                        customer answers the question incorrectly and the points shall revert to
                        basic points i-e 100 points / correct answer.
                    </p>
                    <p align="justify">
                        Streak point calculation example is as follows:
                    </p>
                    <ul>
                        <li className="mbrules">
                            <p align="justify">
                                Question 1 – Question 5 100 Points / correct answer
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Question 6 – Question 10 200 Points / correct answer
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Question 11 – Question 15 300 Points / correct answer
                            </p>
                        </li>
                    </ul>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>11. POWER PLAY MODE</strong>
                            </p>
                        </li>
                    </li>
                    <p align="justify">
                    During the Campaign Period Zong shall also announce the bonus schemes (    <strong>“Power Play”</strong>) at various times where the participant
                        receives more points than the ones he/she can receive in the Basic Mode.
                        Power Play shall only be offered during TEZ T20 &amp; ODI gaming formats.
                        Time allotted to answer questions during Power Play will be less than the
                        Basic Game mode.
                    </p>
                    <p align="justify">
                        There shall be no Power Play mode in TUK TUK TEST gaming format.
                    </p>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>12. CONDITIONS TO WIN AND RECEIVE THE PRIZES</strong>
                            </p>
                        </li>
                    </li>
                    <p align="justify">
                        <strong>12.1</strong>  The Daily Prize, Weekly Prize, Monthly Grand Prize and TOP Ups shall
                        collectively be referred to as the “Prizes” and separately as the “Prize”;
                    </p>
                    <p align="justify">
                        <strong>12.2</strong>  All cash prizes shall be disbursed to the customer via Jazz Cash or
                        Easy Paisa. A participant must provide his Jazz Cash or Easy Paisa account
                        details to claim the prize;
                    </p>
                    <p align="justify">
                        <strong>12.3</strong>  All Prizes will be subject to applicable Taxes before being handed
                        over to the winning Participant;
                    </p>
                    <p align="justify">
                        <strong>12.4</strong>  Daily &amp; weekly cash winning shall be credited to the participant’s
                        virtual Cricwick Wallet. However, a participant may claim the prize
                        money once his wallet balance touches PKR 1,000;
                    </p>
                    <p align="justify">
                        <strong>12.5</strong>  Cash prizes shall only be disbursed into participant’s designated Jazz
                        Cash or easy Paisa account;
                    </p>
                    <p align="justify">
                        <strong>12.6</strong>  The Participants shall be able to win one type of the Prize once only
                        except the TOP Up which can be redeemed multiple times. The Types of Prizes
                        are given below:
                    </p>
                    <ul >
                        <li className="mbrules">
                            <p align="justify">
                                Daily Prize
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Weekly Prize
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Monthly Grand Prize
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Redeemable TOP Ups
                            </p>
                        </li>
                    </ul>
                    <p align="justify">
                        <strong>12.5 </strong> The Prize Winning Participant shall be required to produce his
                        original CNIC for verification of his antecedents from Zong’s records and
                        after verification such Participant shall be given the Prize;
                    </p>
                    <p align="justify">
                        <strong>12.6 </strong> If the winning Participant is under 18, then the prize will be awarded
                        to the person whose name the SIM is registered and the prize will be handed
                        over only after verification in accordance with clause <strong>12.5;</strong> 
                    </p>
                    <p align="justify">
                        <strong>12.7 </strong> Zong reserves the right to disqualify any Participant from receiving
                        any prize(s) if it has reasonable grounds to believe that the Participant
                        breached any provision of the Terms and Conditions and/or the agreement
                        executed for availing Zong Services;
                    </p>
                    <p align="justify">
                        <strong>12.8 </strong> The Prize winning Participant shall be contacted by Zong and such
                        Participant shall undertake in writing that he is, the lawful owner of the
                        SIM and MSISDN (cell number), is entitled to receive the Prize and in case
                        of any claimant disputing the receiving of such Prize he shall be
                        responsible for the settlement of such dispute and shall indemnify Zong in
                        full regarding such dispute (including but not limited to all cost,
                        expenses and reasonable attorney fees incurred by Zong in relation
                        thereto);
                    </p>
                    <p align="justify">
                        <strong>12.9 </strong> The Prize Winning Participant shall provide all the documents required
                        by Zong including a Disclaimer stating that he is not disqualified under
                        Clause 13.14 to participate in the Campaign;
                    </p>
                    <p align="justify">
                        <strong>12.10</strong>  The Participant agrees that Zong may use such photographs, videos and
                        audio recordings taken at the time of Prize distribution, communication
                        happened/exchanged during contact by Zong for intimation of prize winning
                        and other information including names, surnames etc., in Zong’s
                        advertisements of the Campaign without any further/prior/specific consent
                        for such purpose. The consent given here and the incorporation of any
                        contents/information in the advertisement of the Campaign shall not entitle
                        the Participant for any remuneration/amount in any manner. If a winning
                        participant later becomes disqualified under these Terms and Conditions to
                        receive the Prize, then any release of advertisement about his winning
                        shall not create any obligation/responsibility on Zong in favor of such
                        participant either related to the Prize or to any social, financial or
                        other exposure in this regard;
                    </p>
                    <p align="justify">
                        <strong>12.11</strong>  If the notified winner Participant cannot be reached / contacted,
                        disqualified or refuses the Prize or fails to appear to collect it within
                        20 calendar days (the <strong>“Grace Period”</strong>) after the campaign
                        ends, then the claim from winning Participant/runner up shall not be
                        entertained without regard to the reason of such delay/lapse;
                    </p>
                    <p align="justify">
                        <strong>12.12</strong>  The cash Prize Winning Participant must have Jazz Cash or Easy Paisa
                        Account in order to receive the Prize. In case the winner does not have an
                        existing Account, he will be given a period of 15 working days to open Zong
                        Cash or Easy Paisa account and revert back to Zong. In case he does not
                        revert back to Zong in the prescribed time period of 20 days after the
                        campaign ends, it shall be considered the lapse of Grace Period and such
                        Participant shall face the consequences of lapse of Grace Period;
                    </p>
                    <p align="justify">
                        <strong>12.13</strong>  The Prize winner cannot assign or transfer the Prize;
                    </p>
                    <p align="justify">
                        <strong>12.14</strong>  The Participant agrees that Zong shall not be responsible/liable for
                        any loss, injuries or damages of any kind caused to the Participant by or
                        resulting from the Campaign, the participation in the Campaign, acceptance
                        or receiving the Prizes, or disqualification to receive any Prize including
                        without limitation on account of lapse of Grace Period;
                    </p>
                    <p align="justify">
                        <strong>12.15</strong>  Zong reserves the right to stop (Pre-mature Stoppage) the Campaign
                        prior to its last date due to any reasons, including but not limited to as
                        mentioned in clause 13.10 herein. In case of Pre-Mature Stoppage, Zong will
                        publish the results of the Campaign at T&amp;C Link
                        http://cricwick.net/_____________ and shall only give out the prizes
                        won up to the date of Pre-Mature Stoppage;
                    </p>
                    <p align="justify">
                        <strong>12.16</strong>  The Participant understands, agrees and accepts that the decisions
                        made by Zong shall be final and binding on him.
                    </p>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>13. MISCELLANEOUS:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.1</strong>  Zong shall not have any liabilities towards the
                                    Customer/Participant after the expiry of Campaign Period except
                                    provided otherwise expressly in the Terms and Conditions. JC
                                    Coins earned during the campaign may be redeemed anytime as
                                    long as the customer stays subscribed to Cricwick.
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.2</strong>  Zong shall not be responsible for any loss or damage resulting
                                    to the Participant or any third party in any manner in
                                    association and/or connection with the Campaign and
                                    participation therein;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="3">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.3</strong>  Zong undertakes/gives no warranty (whether express or implied)
                                    whatsoever with respect to the entitlement for any Prize by
                                    mere participation of Participant in the Campaign;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="4">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.4</strong>  Fraud or abuse relating to accrual of Points, may result in
                                    forfeiture/cancellation of such accrued Points as well as
                                    cancellation of a Participant’s eligibility for the Campaign,
                                    suspension of Zong’s Services to the Participant and
                                    termination of Participant’s Zong connection; and any decision
                                    by Zong in this respect shall be final;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="5">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.5</strong>  Without prejudice to Clause 13.4, all questions or disputes
                                    regarding eligibility of the Participant for the Campaign, the
                                    accrual/accumulation of Points and giving of Prizes shall be
                                    resolved by Zong in its sole discretion and any decision by
                                    Zong in this respect shall be final;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="6">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.6</strong>  Zong’s failure or delay to enforce a particular term and
                                    condition, right, remedy or penalty shall not constitute as a
                                    waiver of that term and condition, remedy, penalty by Zong.
                                    Further the enforcement of these Terms and Conditions, right,
                                    remedy or penalty shall not mean the waiver of other terms,
                                    remedies or penalties available to Zong under this document,
                                    other applicable documents/agreements between Zong and the
                                    Participant and the relevant laws;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="7">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.7</strong>  Zong reserves the right to disqualify any Participant from
                                    further participation in the Campaign, if it has reason to
                                    believe that the Participant has in any way violated these
                                    Terms and Conditions, or the terms and conditions of the
                                    agreement executed for availing Zong Services (which is
                                    mandatory to execute before availing Zong Services). If a
                                    Participant is availing Zong Services without execution of any
                                    agreement in this regard, it shall be presumed a breach of
                                    these Terms and Conditions in itself;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="8">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.8</strong>  Unless otherwise expressly stated or implied by context, each
                                    of the Terms and Conditions herein contained shall be severable
                                    and distinct from one another and if any provision of these
                                    Terms and Conditions is held to be invalid, illegal or
                                    unenforceable by a court of competent jurisdiction or any
                                    competent authority, such invalidity, illegality or
                                    unenforceability shall not affect the validity, legality and
                                    enforceability of the remaining provisions. In case any
                                    provision is held to be invalid, illegal or unenforceable by a
                                    competent authority or court, Zong shall have the right to
                                    amend these Terms and Conditions as may be required as a result
                                    of the order of the competent court or authority. However, in
                                    case the remaining Terms and Conditions cannot survive pursuant
                                    to the order of the competent authority or court, or the
                                    amendment renders these Terms &amp; Condition incapable of
                                    being performed to the extent of obligations with regards to a
                                    Participant/Prize winner, the Participant/Prize winner
                                    understands, accepts and agrees that Zong in such circumstances
                                    shall have the right to terminate the agreement concluded
                                    between Zong and the Participant hereby;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="9">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.9</strong>  If a Force Majeure event occurs that directly affects the
                                    ability of Zong to perform its obligations hereunder, Zong
                                    shall be entitled to suspend performance of such an obligation
                                    for the duration of the Force Majeure event. Force Majeure
                                    includes acts of God, war, hostilities, riots, civil commotion,
                                    strike, revolution, epidemic, accident, fire, flood,
                                    earthquake, blockade, any decision of the court, tribunal or
                                    authority, PTA or any other cause similar to the kind herein
                                    enumerated or of equivalent force not within the control of
                                    Zong (including but not limited to reasons attributable to
                                    failure of machinery, Zong’s telecommunication system, any
                                    hardware or software);
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="10">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.10</strong>  The decision of Zong in respect of any dispute that may arise
                                    in connection with these Terms and Conditions shall be final
                                    and binding on the Participant;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="11">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.11</strong>  The Customer/Participant acknowledges that under this Campaign
                                    he shall not respond to any calls/SMSs directing to make/send
                                    calls/SMSs to any other number/short code or which are
                                    regarding award of any prize (whether money or in kind) in lieu
                                    of balance transfer or any call. Ignorance of this clause by
                                    the Customer shall not accrue any liabilities/responsibilities
                                    on Zong including but not limited to liability/responsibility
                                    towards any loss occurred to the Customer/Participant;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="12">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.12</strong>  The language of the Campaign shall be Roman Urdu and/or
                                    English;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="13">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.13</strong>  The Customer who has executed the agreement for availing Zong
                                    Services against the MSISDN (cell number) under his use shall
                                    be eligible to participate in the Campaign and not otherwise.
                                    However, notwithstanding anything contained herein, the
                                    following shall not be eligible to participate in the Campaign:
                                </p>
                            </li>
                        </li>
                    </li>
                    <ul >
                        <li className="mbrules">
                            <p align="justify">
                                The employees of Zong;
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Zong Franchises and Retailers and the employees of its sister
                                concerns;
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                    The spouse, children, parents and siblings (            <strong>“First Degree Relatives”</strong>) of Zong employees;
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                The registered users of Zong employee family number; and
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                The contractors, technical service providers and/or professionals
                                and their employees working for this Campaign.
                            </p>
                        </li>
                    </ul>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>
                                    14. COMPLAINT/QUERY HANDLING, DISPUTE RESOLUTION AND ARBITRATION:
                                </strong>
                            </p>
                        </li>
                    </li>
                    <p align="justify">
                        <b>  14.1</b>  The Participant can call at the helpline by dialing 300 round the
                        clock for any complaints regarding the Campaign. The Participant’s call
                        shall be recorded against his CLI for record keeping and in accordance with
                        the instructions given by PTA. Prescribed tariff rates shall be charged for
                        using the helpline services;
                    </p>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <b>14.2</b>  If a Participant requires information regarding the Campaign or
                                    the Trivia, he can access FAQ, Game Rules &amp; detailed
                                    T&amp;C available on Cricwick mobile app and web;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <b>14.3</b>  A Participant can check his rank by accessing the leaderboard
                                    available on the Cricwick mobile app and web;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="3">
                            <li className="mbrules">
                                <p align="justify">
                                <b>14.4</b>  The Campaign and/or the Trivia and these Terms and Conditions
                                    shall be governed by the laws of Pakistan and interpreted in
                                    accordance with laws of Pakistan. If the Participant shall be
                                    of the opinion that he has any right pertaining to the Campaign
                                    and he wishes to invoke such right, the Participant
                                    acknowledges, understands and agrees that such right can only
                                    be invoked through the arbitration which shall be conducted by
                                    the sole arbitrator appointed by Zong and such arbitration
                                    proceedings shall be conducted in English or Urdu language at
                                    Lahore under the Arbitration Act 1940. Without prejudice to the
                                    above, it is further agreed by the Participant that only the
                                    courts at Lahore shall have the jurisdiction on any matter
                                    relating to the Campaign.
                                </p>
                            </li>
                        </li>
                    </li>
            
                </div>
            )
        } else if (operatorName === "ufone") { //ufone
            return (
                <div style={{ fontSize: '14px' }} className="px-3 info">
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>1. INTRODUCTION:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <b>1.1</b>  Pak Telecom Mobile Limited (henceforth                <strong>Ufone</strong>) provides telecommunication services in
                    the Islamic Republic of Pakistan, AJK and Gilgit Baltistan (the                <strong>“Territory”</strong>). Ufone is offering various value
                    added services <strong>(“VAS”) </strong>which also<strong> </strong>includes short messaging service (                <strong>“SMS”</strong>);
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <b>1.2</b>  A new feature (the                <strong>“Master Blaster League”</strong>) is being introduced in Cricwick 
                                    “The VAS product”. The Master Blaster League in its introductory
                                    launch period shall be available for a period of 90 days and
                                    may be extended thereafter. The participation in Master Blaster
                                    League is subject to the successful subscription of Cricwick
                                    at PKR 2.39 plus tax (Govt. tax of 19.5% is applicable) per day (defined as                <strong>“Charges”</strong> below);
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="3">
                            <li className="mbrules">
                                <p align="justify">
                                <b>1.3</b>  Ufone is launching a specially designed marketing campaign                <strong>(</strong>the <strong>“Campaign”) </strong>to promote
                                    its VAS Product “Cricwick” and its newly introduced feature
                                    “Master Blaster League”<strong>. </strong>The Campaign includes
                                    incentives for the Customers subscribing to the Cricwick
                                    and engaging in with the Daily Tasks on the platform, including
                                    the free of cost participation in the Trivia and win a wide
                                    array of cash prizes detailed hereunder. The duration of the
                                    Campaign shall be the introductory period of the Master Blaster
                                    League (i.e. 90 days). Ufone has created a webpage
                    http://cricwick.net/_________ (                <strong>“T&amp;C Link”</strong>) and made these Terms and
                                    Conditions (as defined below) available on the Cricwick
                                    mobile app to provide detailed information pertaining to the
                                    Campaign. The Website is publically accessible, whereas the
                                    mobile app shall be accessible to Cricwick subscribers
                                    only;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="4">
                            <li className="mbrules">
                                <p align="justify">
                                <b>1.4</b>  The terms and conditions mentioned herein (                <strong>“Terms and Conditions”</strong>) shall determine the
                                    rights and liabilities of Ufone and the Customer (as defined
                                    below) regarding the Cricwick subscription and also the
                                    Campaign. In order to purchase the subscription to the Ufone
                                    Cricket and consequently also to participate in the Campaign,
                                    the Customer shall accept these Terms and Conditions in their
                                    totality by clicking on the <strong>“Let’s Start”</strong>
                                    button on the Cricwick mobile app and web page. The click
                                    on the button therein, would be for all intents and purposes be
                                    deemed as acceptance on the part of the Customer with these
                                    Terms and Conditions in their totality. The sole consideration
                                    granting the Customer the right to participate in the Campaign
                                    is the subscription to the Cricwick.
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>2. DEFINITIONS AND INTERPRETATIONS:</strong>
                            </p>
                        </li>
                    </li>
                    <p align="justify">
                        <strong>2.1 </strong>
                        <em><strong>Definitions:</strong></em>
                    </p>
                    <p lang="x-none" align="justify">
                        Unless the context requires otherwise, the expressions used in these Terms
                        and Conditions and not defined elsewhere in such Terms and Condition shall
                        have the following meanings assigned to them:
                    </p>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                    <strong>2.1.1 "Advertisement”</strong> or                    <strong>“Advertised by Ufone”</strong> means publication or
                                        advertisement of any information, policy, notice,
                                        intimation, public message or any other communication
                                        regarding the Campaign, collectively or separately, through
                                        any medium including but not limited to digital,
                                        television, radio, outdoor, hoardings/billboards, internet,
                                        cellular and/or print media, SMS Broadcast etc.;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.2 "Terms and Conditions” </strong>means these terms
                                        and conditions;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.3 "Approved modes of communication”</strong> means
                                        any of the modes of communication provided in Telecom
                                        Consumer Protection Regulations, 2009 as amended from time
                                        to time;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.4 "Charges” </strong>means the price for the
                                        subscription of Cricwick (inclusive of taxes) which
                                        shall automatically be charged to the Customer on daily
                                        basis recursively after the Subscription of the Customer to
                                        the Cricwick in accordance with these Terms and
                                        Conditions and it shall continue to be charged until the
                                        Customer unsubscribed from availing the Cricwick
                                        product;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.5 "Connection”</strong> means Post-paid Connection or
                                        Pre-paid Connection issued by Ufone to the Customers;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.6 "Customer”</strong> means the customer (including
                                        natural or legal person) who is availing Ufone Services
                                        through an MSISDN registered and activated validly in his
                                        name at the time of Subscribing to the Cricwick;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.7 "Encryption”</strong> means any technique used by
                                        Ufone to reasonably secure the data, voice transmission or
                                        other communication over the System including but not
                                        limited to prevent eaves dropping over its
                                        telecommunication system except as required by the law or
                                        beyond its reasonable control;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.8 Data</strong><strong>”</strong> means General
                                        Packet Radio Service or Long Term Evolution Service offered
                                        by Ufone to the Customers;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.9 "License”</strong> means the relevant GSM License
                                        issued to Ufone by PTA for provision of Services in the
                                        Territory;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.10 "Master Blaster League” </strong>means a bundle of
                                        daily tasks for Cricwick subscribers to complete and
                                        earn redeemable points;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.11 "MSISDN Number”</strong> means a unique numerical
                                        number assigned against each Connection for availing Ufone
                                        Services;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.12 "Network”</strong> means Ufone’s GSM network as and
                                        where installed throughout the Territory which is run and
                                        supported by the System;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.13 "Participant”</strong> means the Customer who has
                                        elected to participate in the Campaign as per these Terms
                                        and Conditions;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.14 "Parties” </strong>unless the context provides
                                        otherwise means Ufone and the Participant Customers;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.15 "Payables”</strong> or <strong>“Dues”</strong> mean
                                        any payments due against the Customer for availing Ufone
                                        Services as per the relevant agreement thereof;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                    <strong>2.1.16 "Points” or “Pts” </strong><strong>or</strong><strong>“</strong><strong>Scores</strong><strong>”</strong>                    <strong> </strong>means points earned by the Participant
                                        upon answering a Trivia Question on the Cricwick mobile
                                        app or web. The Points shall be used to rank participants
                                        for the Daily and Weekly Top Scorer Prizes;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                    <strong>2.1.17 "Coins</strong><strong>” or “</strong>                    <strong>Coins</strong><strong>”</strong> means a virtual
                                        currency earned by the Participant by completing the daily
                                        tasks on the Cricwick mobile app or web. The Coins may
                                        be redeemed by the subscribers of Cricwick in the form
                                        of pre-paid Top Ups;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.18 "Wallet” </strong>means the virtual wallet where
                                        a participant’s Daily and Weekly winnings shall be credited
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.19 "Post-paid Connection”</strong> means such
                                        Connection for which the Customer, subject to deposit of
                                        any applicable advance or security, pays for the Ufone
                                        Services after availing the Services;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.20 "Pre-paid Connection”</strong> means such
                                        Connection for which the Customer pays for the Ufone
                                        Services in advance before availing such Services;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.21 "PTA”</strong> means Pakistan Telecommunication
                                        Authority or its successor;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.22 "SIM Card”</strong> means subscriber identity
                                        module card corresponding to the unique MSISDN Number
                                        issued to a Customer;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.23 "SMS” </strong>means the Short Messaging Service
                                        provided by Ufone, but the expression “SMS” used in these
                                        terms and condition shall mean either (i) the SMS sent to
                                        customers and subscribers as invitations and / or service
                                        intimations;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.24 "System”</strong> means Ufone’s GSM mobile cellular
                                        system;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.25 "Taxes” or “t”</strong> include all or any taxes,
                                        levies or fees levied/charged by federal government, any
                                        provincial government or any other lawfully competent
                                        authority;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.26 "Territory”</strong> means the territories for
                                        which Ufone is authorized to provide Services under the
                                        License;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                    <strong>2.1.27 "Value Added Services”</strong> or                    <strong>“VAS”</strong> means any value added services
                                        offered by Ufone from time to time to its Customers;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.28 "Ufone Services”</strong> means the services offered
                                        by Ufone from time to time through the System and Network
                                        including mandatory cellular services and optional services
                                        pursuant to the License; and
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.29 "Ufone”</strong> means Pak Telecom Mobile
                                        Limited. (including its successors and assigns) licensed by
                                        PTA to install and operate the Network throughout the
                                        Territory in order to provide the Services.
                                    </p>
                                </li>
                            </li>
                        </li>
                    </li>
                    <p align="justify">
                        <strong>2.2 </strong>
                        <em><strong>Interpretation</strong></em>
                        <strong>s:</strong>
                    </p>
                    <p lang="en-GB" align="justify">
                    <strong>2.2.1 </strong> Headings are included for convenience only and shall not affect the
                        interpretation hereof. Any reference to the singular shall include the
                        plural and vice versa and any reference to one gender shall include all
                        genders;
                    </p>
                    <p lang="en-GB" align="justify">
                    <strong>2.2.2 </strong> The importance of Clauses shall not be determined by their
                        arrangement/order in these Terms and Conditions;
                    </p>
                    <p lang="en-GB" align="justify">
                    <strong>2.2.3 </strong> The words “include”, “includes”, “including” and “included” will be
                        construed without limitation unless inconsistent with the context; and
                    </p>
                    <p lang="en-GB" align="justify">
                    <strong>2.2.4 </strong> The words not expressly defined herein shall bear the dictionary
                        meanings.
                    </p>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>3 CHANGES IN THE TERMS AND CONDITIONS:</strong>
                            </p>
                        </li>
                    </li>
                    <p align="justify">
                        Ufone maintains the absolute right to amend these Terms and Conditions by
                        publishing the amendments and changes on Cricwick official web site.
                        However, the Customer shall be intimated through an SMS from the Cricwick short code
                        or an SMS from Ufone prior to any such amendment or change taking
                        effect.
                    </p>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>4 SHORT CODES:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                    <a name="_GoBack"></a>
                                    <strong>4.1</strong>  Short Code:
                                </p>
                            </li>
                        </li>
                    </li>
                    <p align="justify">
                        The Cricwick Short Code shall be used for sending invitations to participate in the
                        campaign and/or service intimations by Ufone.
                    </p>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>
                                    5. THE MASTER BLASTER LEAGUE; PRODUCT TERMS AND DETAILS
                                </strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>5.1</strong>  The Master Blaster League is a new product feature being made
                                    available for an introductory launch period and shall be
                                    available to the Customers of Ufone via subscribing to Ufone
                                    Cricket;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>5.2</strong>  The Customer understands, accepts and agrees that the
                                    subscription to Cricwick will result in the free of cost
                                    participation in the Master Blaster League and clicking on the
                                    “Let’s Play” button shall represent an unconditional acceptance
                                    of these Terms and Conditions in their totality whereof the
                                    link shall be sent to the Customer in an SMS;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="3">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>5.3</strong>  The Master Blaster League consists of a list of Daily Tasks
                                    including but not limited to the following:
                                </p>
                            </li>
                        </li>
                    </li>
                    <ul>
                        <li className="mbrules">
                            <p align="justify">
                                Watch videos on Cricwick
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Share a content on their social media
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Share a referral
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Daily come back bonus
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Open Cricwick app for 5 consecutive days
                            </p>
                        </li>
                    </ul>
                    <li className="mbrules">
                        <li start="4">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>5.4</strong>  The Cricwick subscription price is PKR 2.39 plus 19.5% tax, which
                                    shall be charged automatically to the Customer at the start of
                                    each day until such time as the Customer unsubscribes from the
                                    Cricwick platform. When a Customer confirms subscription of
                                    the Cricwick, Customer shall be charged the Charges on a
                                    daily recursive basis in accordance with these Terms and
                                    Conditions. Against such daily Charges the Customer shall avail
                                    all content and features of Cricwick. Customers having
                                    Post-paid connections may use Cricwick or participate in
                                    Master Blaster League, however they are not eligible to claim
                                    any prizes offered in the campaign;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="5">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>5.5</strong>  Customer earning the Coin may redeem them as per the
                                    criteria anytime during the time of his subscription to Ufone
                                    Cricket platform.
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="6">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>5.6</strong>  If any Customer desires to be unregistered as a subscriber of
                                    the Cricwick, he/she shall do it from the Cricwick
                                    mobile app or web;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="7">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>5.7</strong>  If a Customer decides to re-subscribe after unsubscribing from
                                    the Cricwick, he/she can re-subscribe via Cricwick
                                    mobile app or web, and consequently participate in the
                                    Campaign.<strong> </strong>All previously accumulated Points
                                    from the Campaign will also automatically become available for
                                    the re-subscribed Participant if so available for the defined
                                    and relevant period of the Campaign. The re-subscription of a
                                    Customer shall also represent that the Customer has again
                                    unconditionally accepted the Terms and Conditions.
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>6. DETAILS OF CAMPAIGN:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>6.1</strong>  The Customer acknowledges that Ufone has primarily launched this
                                    Campaign to promote Cricwick platform and specifically the
                                    Master Blaster League which has been introduced hereby;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>6.2</strong>  All Customers upon electing to subscribe to the Cricwick by
                                    accepting the Terms and Conditions in the manner prescribed
                                    herein shall become the Participants of the Campaign in in
                                    accordance with these Terms and Conditions;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="3">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>6.3</strong>   To participate in the Campaign, the Customer shall be
                                    registered as a Participant upon the subscription to the Ufone
                                    Cricket consequent to the acceptance of the Terms and
                                    Conditions
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="4">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>6.4</strong>  After registration as a Participant, the Participant shall
                                    become eligible to avail the benefits of the Campaign including
                                    entry in the offered Trivia under the Campaign where the entry
                                    shall be free of cost;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="5">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>6.5</strong>  If a customer fails to pay Cricwick’s subscription charges
                                    i-e PKR 2.39 plus 19.5% tax, for 15 consecutive days, he shall not be
                                    eligible to participate in the Trivia offered under Master
                                    Blaster League
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="6">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>6.6</strong>  The Customer/Participant acknowledges that a number of SMS
                                    and/or in-app notifications for the promotion of the Campaign
                                    and service engagement will be sent throughout the duration of
                                    the Campaign;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>7. DURATION OF THE CAMPAIGN:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>7.1</strong>   The duration of the Campaign shall be till the end of the
                                    specified duration and period of the introductory Master
                    Blaster League as determined by Ufone (the                <strong>“Campaign Period”</strong>);
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>7.2</strong>  Ufone may terminate/discontinue the Campaign at any time during
                                    the Campaign Period; however, the Customer/Participant shall be
                                    intimated in accordance with the applicable laws before the
                                    termination/discontinuation date. After the
                                    termination/discontinuation of the Campaign or expiry of
                                    Campaign Period, Ufone bears no obligation towards the
                                    Customer/Participant without any limitation.
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="3">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>7.3</strong>  In the event that the Customer unregisters his subscription of
                                    the Cricwick during the Campaign Period, the participation
                                    in the Campaign shall also stand suspended however, the
                                    accumulated Points and Coins will be retained and the
                                    Customer will be eligible for prizes if applicable for the
                                    period of participation in the Campaign;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>8. OBLIGATIONS OF CUSTOMER/PARTICIPANT:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>8.1</strong>  The Customer/Participant unconditionally accepts these Terms
                                    and Conditions in addition to the terms and conditions agreed
                                    by the Customer in hard document or electronically for availing
                                    Ufone’s cellular services at the time of getting Connection and
                                    shall absolutely comply with them.
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>8.2</strong>  The Customer/Participant shall refrain from any illegal, unfair
                                    or improper actions/deeds/omissions while subscription of the
                                    Cricwick and participating in the Campaign and for getting
                                    the benefits of the Campaign; and in the event of such an
                                    attempt occurring, Ufone shall have all the rights available to
                                    it under these Terms and Conditions, the agreement executed by
                                    the Customer for availing any of Ufone’s Services and the
                                    applicable laws;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>9. MASTER BLASTER PRIZES AND MECHANICS:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>9.1</strong>  The prizes in Master Blaster League shall be the pre-paid TOP
                                    Up of PKR 50 per redemption and Grand Prize of PKR 300,000 to
                                    be distributed among Top 50 scorers in the Master Blaster
                                    League every month. The distribution will be as follows:
                                </p>
                            </li>
                        </li>
                    </li>
                    <ul>
                        <li>
                            <p align="justify">
                                Winner i-e Top Scorer in the Master Blaster League shall receive
                                PKR 20,000
                            </p>
                        </li>
                        <li>
                            <p align="justify">
                                1<sup>st</sup> &amp; 2<sup>nd</sup> Runners Up shall receive PKR 15,000 each
                            </p>
                        </li>
                        <li>
                            <p align="justify">
                                3<sup>rd</sup>, 4<sup>th</sup> &amp; 5<sup>th</sup> Runners Up shall receive PKR
                                10,000 each
                            </p>
                        </li>
                        <li>
                            <p align="justify">
                                6<sup>th</sup> till 9<sup>th</sup> Runners Up shall receive PKR
                                5,000 each
                            </p>
                        </li>
                    </ul>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>9.2</strong>  If 2 or more participants share the same rank, then the prize
                                    for that rank shall be distributed equally among all
                                    participants sharing that rank.
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                <strong>9.3</strong>  The participant MUST complete the daily tasks to earn Coins,
                                    which thereafter shall be redeemed against the prizes of the
                                    Master Blaster League i-e Top Ups;
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                <strong>9.4</strong>   A customer shall only redeem one TOP Up prize daily;
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                <strong>9.5</strong>   1 Coin will be awarded for every 50 points earned by
                                    completing the daily tasks;
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                <strong>9.6</strong>  1 Coin equals to the value of PKR 1. Hence TOP Up of PKR 50
                                    shall only be redeemed upon earning 50 Coins;
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                <strong>9.7</strong>   Point shall be earned by completing the following tasks but not
                                    limited to:
                                </p>
                            </li>
                        </li>
                    </li>
                    <ul>
                        <li className="mbrules">
                            <p align="justify">
                                For every video content on Cricwick watched for a minimum of 30
                                seconds by a participant shall receive upon fulfilling the criteria
                                20 points. Maximum 3 video views shall be counted for the campaign.
                                A total of 60 points may be earned per day;
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                For every Cricwick video shared on participant’s social media
                                shall receive upon fulfilling the criteria 10 points. The points
                                shall be awarded only once the shared link is being clicked /
                                accessed on social media. The points shall only awarded once the
                                shared link is clicked.
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                For every referral / inviting friends &amp; family on Cricwick
                                shall receive upon fulfilling the criteria 100 points. The points
                                shall be awarded only once the invited referral subscribes to the
                                Cricwick platform;
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                For opening the app every day, the customer shall get the points in
                                the following manner:
                            </p>
                        </li>
                    </ul>
                    <ul>
                        <ul>
                            <li className="mbrules">
                                <p align="justify">
                                    Day1 10 Points
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                    Day 2 20 Points
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                    Day 3 30 Points
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                    Day 4 40 Points
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                    Day 5 50 Points
                                </p>
                            </li>
                        </ul>
                    </ul>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>10. TRIVIA PRIZES AND MECHANICS:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>10.1</strong>  Ufone as a part of the Campaign has introduced Trivia Games (the                <strong>“Trivia”</strong>) which is part of the Campaign;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>10.2</strong>  The Participant of his own free will may elect to participate
                                    in the Trivia;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="3">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>10.3</strong>  The Participant may as part of the Campaign to promote the new
                                    feature of Cricwick i-e Master Blaster League, also play
                                    any of the 3 offered Trivia Gaming formats i-e Tez T20, ODI
                                    &amp; Tuk Tuk Test. The Participant/Customer shall not be
                                    charged anything for participating in the Trivia
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="4">
                            <li className="mbrules">
                                <p align="justify">
                                    <strong>10.4 TEZ T20:</strong>
                                </p>
                            </li>
                        </li>
                    </li>
                    <p align="justify">
                        During the Campaign Period, on every day starting from 00:00:00 and ending
                        on 23:59:59, participants MUST answer 10 questions. Daily cash prize of PR
                        10,000 shall be equally distributed among the Top 150 Participants earning
                        maximum Points by answering the Trivia Questions in TEZ T20.
                    </p>
                    <p align="justify">
                        Only 1 (One) TEZ T20 game may be played in a day.
                    </p>
                    <p align="justify">
                        100 Points shall be awarded for every correct answer during the basic play
                        mode. Whereas 300 points shall be awarded for every correct answer during
                        the Power Play mode. Wrong answers will have ZERO points.
                    </p>
                    <p align="justify">
                        Power Play mode may be offered anytime during the game.
                    </p>
                    <p align="justify">
                        Answers MUST be given within the allotted time
                    </p>
                    <ul>
                        <li className="mbrules">
                            <p align="justify">
                                Time allotted for every questions during Basic Game mode shall be
                                10 seconds
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Time allotted for every questions during Power Play mode shall be 7
                                seconds
                            </p>
                        </li>
                    </ul>
                    <p align="justify">
                        <strong>10.5 ODI</strong>
                    </p>
                    <p align="justify">
                        During the Campaign Period, on every day starting from 00:00:00 and ending
                        on 23:59:59, participants MUST answer 30 questions. Daily cash prize of PR
                        20,000 shall be equally distributed among the Top 200 Participants earning
                        maximum Points by answering the Trivia Questions in ODI.
                    </p>
                    <p align="justify">
                        Only 1 (One) ODI game may be played in a day.
                    </p>
                    <p align="justify">
                        200 Points shall be awarded for every correct answer during the basic play
                        mode. Whereas 400 points shall be awarded for every correct answer during
                        the Power Play mode. Wrong answers will have ZERO points.
                    </p>
                    <p align="justify">
                        Power Play mode may be offered anytime during the game.
                    </p>
                    <p align="justify">
                        Answers MUST be given within the allotted time
                    </p>
                    <ul>
                        <li className="mbrules">
                            <p align="justify">
                                Time allotted for every questions during Basic Game mode shall be
                                15 seconds
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Time allotted for every questions during Power Play mode shall be
                                10 seconds
                            </p>
                        </li>
                    </ul>
                    <p align="justify">
                        <strong>10.6 TUK TUK TEST:</strong>
                    </p>
                    <p align="justify">
                        During the Campaign Period, every week starting from Monday 00:00:00 and
                        ending on Sunday 23:59:59, participants MUST play for at least 3 days and
                        answer 30 questions / day. Weekly cash prize of PR 40,000 shall be equally
                        distributed among the Top 200 Participants earning maximum Points by
                        answering the Trivia Questions in TEST.
                    </p>
                    <p align="justify">
                        A participant may play the TEST game for a maximum of 5 days in a week.
                    </p>
                    <p align="justify">
                        100 Points shall be awarded for every correct answer during the basic play
                        mode. Whereas for every 5 (five) correct answers, a streak shall be
                        activated where participants shall get multiples of basic points. Wrong
                        answers will have ZERO points. Streak shall be discontinued once the
                        customer answers the question incorrectly and the points shall revert to
                        basic points i-e 100 points / correct answer.
                    </p>
                    <p align="justify">
                        Streak point calculation example is as follows:
                    </p>
                    <ul>
                        <li className="mbrules">
                            <p align="justify">
                                Question 1 – Question 5 100 Points / correct answer
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Question 6 – Question 10 200 Points / correct answer
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Question 11 – Question 15 300 Points / correct answer
                            </p>
                        </li>
                    </ul>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>11. POWER PLAY MODE</strong>
                            </p>
                        </li>
                    </li>
                    <p align="justify">
                    During the Campaign Period Ufone shall also announce the bonus schemes (    <strong>“Power Play”</strong>) at various times where the participant
                        receives more points than the ones he/she can receive in the Basic Mode.
                        Power Play shall only be offered during TEZ T20 &amp; ODI gaming formats.
                        Time allotted to answer questions during Power Play will be less than the
                        Basic Game mode.
                    </p>
                    <p align="justify">
                        There shall be no Power Play mode in TUK TUK TEST gaming format.
                    </p>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>12. CONDITIONS TO WIN AND RECEIVE THE PRIZES</strong>
                            </p>
                        </li>
                    </li>
                    <p align="justify">
                        <strong>12.1</strong>  The Daily Prize, Weekly Prize, Monthly Grand Prize and TOP Ups shall
                        collectively be referred to as the “Prizes” and separately as the “Prize”;
                    </p>
                    <p align="justify">
                        <strong>12.2</strong>  All cash prizes shall be disbursed to the customer via Jazz Cash or
                        Easy Paisa. A participant must provide his Jazz Cash or Easy Paisa account
                        details to claim the prize;
                    </p>
                    <p align="justify">
                        <strong>12.3</strong>  All Prizes will be subject to applicable Taxes before being handed
                        over to the winning Participant;
                    </p>
                    <p align="justify">
                        <strong>12.4</strong>  Daily &amp; weekly cash winning shall be credited to the participant’s
                        virtual Cricwick Wallet. However, a participant may claim the prize
                        money once his wallet balance touches PKR 1,000;
                    </p>
                    <p align="justify">
                        <strong>12.5</strong>  Cash prizes shall only be disbursed into participant’s designated Jazz
                        Cash or easy Paisa account;
                    </p>
                    <p align="justify">
                        <strong>12.6</strong>  The Participants shall be able to win one type of the Prize once only
                        except the TOP Up which can be redeemed multiple times. The Types of Prizes
                        are given below:
                    </p>
                    <ul >
                        <li className="mbrules">
                            <p align="justify">
                                Daily Prize
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Weekly Prize
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Monthly Grand Prize
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Redeemable TOP Ups
                            </p>
                        </li>
                    </ul>
                    <p align="justify">
                        <strong>12.5 </strong> The Prize Winning Participant shall be required to produce his
                        original CNIC for verification of his antecedents from Ufone’s records and
                        after verification such Participant shall be given the Prize;
                    </p>
                    <p align="justify">
                        <strong>12.6 </strong> If the winning Participant is under 18, then the prize will be awarded
                        to the person whose name the SIM is registered and the prize will be handed
                        over only after verification in accordance with clause <strong>12.5;</strong> 
                    </p>
                    <p align="justify">
                        <strong>12.7 </strong> Ufone reserves the right to disqualify any Participant from receiving
                        any prize(s) if it has reasonable grounds to believe that the Participant
                        breached any provision of the Terms and Conditions and/or the agreement
                        executed for availing Ufone Services;
                    </p>
                    <p align="justify">
                        <strong>12.8 </strong> The Prize winning Participant shall be contacted by Ufone and such
                        Participant shall undertake in writing that he is, the lawful owner of the
                        SIM and MSISDN (cell number), is entitled to receive the Prize and in case
                        of any claimant disputing the receiving of such Prize he shall be
                        responsible for the settlement of such dispute and shall indemnify Ufone in
                        full regarding such dispute (including but not limited to all cost,
                        expenses and reasonable attorney fees incurred by Ufone in relation
                        thereto);
                    </p>
                    <p align="justify">
                        <strong>12.9 </strong> The Prize Winning Participant shall provide all the documents required
                        by Ufone including a Disclaimer stating that he is not disqualified under
                        Clause 13.14 to participate in the Campaign;
                    </p>
                    <p align="justify">
                        <strong>12.10</strong>  The Participant agrees that Ufone may use such photographs, videos and
                        audio recordings taken at the time of Prize distribution, communication
                        happened/exchanged during contact by Ufone for intimation of prize winning
                        and other information including names, surnames etc., in Ufone’s
                        advertisements of the Campaign without any further/prior/specific consent
                        for such purpose. The consent given here and the incorporation of any
                        contents/information in the advertisement of the Campaign shall not entitle
                        the Participant for any remuneration/amount in any manner. If a winning
                        participant later becomes disqualified under these Terms and Conditions to
                        receive the Prize, then any release of advertisement about his winning
                        shall not create any obligation/responsibility on Ufone in favor of such
                        participant either related to the Prize or to any social, financial or
                        other exposure in this regard;
                    </p>
                    <p align="justify">
                        <strong>12.11</strong>  If the notified winner Participant cannot be reached / contacted,
                        disqualified or refuses the Prize or fails to appear to collect it within
                        20 calendar days (the <strong>“Grace Period”</strong>) after the campaign
                        ends, then the claim from winning Participant/runner up shall not be
                        entertained without regard to the reason of such delay/lapse;
                    </p>
                    <p align="justify">
                        <strong>12.12</strong>  The cash Prize Winning Participant must have Jazz Cash or Easy Paisa
                        Account in order to receive the Prize. In case the winner does not have an
                        existing Account, he will be given a period of 15 working days to open Ufone
                        Cash or Easy Paisa account and revert back to Ufone. In case he does not
                        revert back to Ufone in the prescribed time period of 20 days after the
                        campaign ends, it shall be considered the lapse of Grace Period and such
                        Participant shall face the consequences of lapse of Grace Period;
                    </p>
                    <p align="justify">
                        <strong>12.13</strong>  The Prize winner cannot assign or transfer the Prize;
                    </p>
                    <p align="justify">
                        <strong>12.14</strong>  The Participant agrees that Ufone shall not be responsible/liable for
                        any loss, injuries or damages of any kind caused to the Participant by or
                        resulting from the Campaign, the participation in the Campaign, acceptance
                        or receiving the Prizes, or disqualification to receive any Prize including
                        without limitation on account of lapse of Grace Period;
                    </p>
                    <p align="justify">
                        <strong>12.15</strong>  Ufone reserves the right to stop (Pre-mature Stoppage) the Campaign
                        prior to its last date due to any reasons, including but not limited to as
                        mentioned in clause 13.10 herein. In case of Pre-Mature Stoppage, Ufone will
                        publish the results of the Campaign at T&amp;C Link
                        http://cricwick.net/_____________ and shall only give out the prizes
                        won up to the date of Pre-Mature Stoppage;
                    </p>
                    <p align="justify">
                        <strong>12.16</strong>  The Participant understands, agrees and accepts that the decisions
                        made by Ufone shall be final and binding on him.
                    </p>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>13. MISCELLANEOUS:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.1</strong>  Ufone shall not have any liabilities towards the
                                    Customer/Participant after the expiry of Campaign Period except
                                    provided otherwise expressly in the Terms and Conditions. JC
                                    Coins earned during the campaign may be redeemed anytime as
                                    long as the customer stays subscribed to Cricwick.
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.2</strong>  Ufone shall not be responsible for any loss or damage resulting
                                    to the Participant or any third party in any manner in
                                    association and/or connection with the Campaign and
                                    participation therein;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="3">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.3</strong>  Ufone undertakes/gives no warranty (whether express or implied)
                                    whatsoever with respect to the entitlement for any Prize by
                                    mere participation of Participant in the Campaign;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="4">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.4</strong>  Fraud or abuse relating to accrual of Points, may result in
                                    forfeiture/cancellation of such accrued Points as well as
                                    cancellation of a Participant’s eligibility for the Campaign,
                                    suspension of Ufone’s Services to the Participant and
                                    termination of Participant’s Ufone connection; and any decision
                                    by Ufone in this respect shall be final;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="5">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.5</strong>  Without prejudice to Clause 13.4, all questions or disputes
                                    regarding eligibility of the Participant for the Campaign, the
                                    accrual/accumulation of Points and giving of Prizes shall be
                                    resolved by Ufone in its sole discretion and any decision by
                                    Ufone in this respect shall be final;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="6">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.6</strong>  Ufone’s failure or delay to enforce a particular term and
                                    condition, right, remedy or penalty shall not constitute as a
                                    waiver of that term and condition, remedy, penalty by Ufone.
                                    Further the enforcement of these Terms and Conditions, right,
                                    remedy or penalty shall not mean the waiver of other terms,
                                    remedies or penalties available to Ufone under this document,
                                    other applicable documents/agreements between Ufone and the
                                    Participant and the relevant laws;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="7">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.7</strong>  Ufone reserves the right to disqualify any Participant from
                                    further participation in the Campaign, if it has reason to
                                    believe that the Participant has in any way violated these
                                    Terms and Conditions, or the terms and conditions of the
                                    agreement executed for availing Ufone Services (which is
                                    mandatory to execute before availing Ufone Services). If a
                                    Participant is availing Ufone Services without execution of any
                                    agreement in this regard, it shall be presumed a breach of
                                    these Terms and Conditions in itself;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="8">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.8</strong>  Unless otherwise expressly stated or implied by context, each
                                    of the Terms and Conditions herein contained shall be severable
                                    and distinct from one another and if any provision of these
                                    Terms and Conditions is held to be invalid, illegal or
                                    unenforceable by a court of competent jurisdiction or any
                                    competent authority, such invalidity, illegality or
                                    unenforceability shall not affect the validity, legality and
                                    enforceability of the remaining provisions. In case any
                                    provision is held to be invalid, illegal or unenforceable by a
                                    competent authority or court, Ufone shall have the right to
                                    amend these Terms and Conditions as may be required as a result
                                    of the order of the competent court or authority. However, in
                                    case the remaining Terms and Conditions cannot survive pursuant
                                    to the order of the competent authority or court, or the
                                    amendment renders these Terms &amp; Condition incapable of
                                    being performed to the extent of obligations with regards to a
                                    Participant/Prize winner, the Participant/Prize winner
                                    understands, accepts and agrees that Ufone in such circumstances
                                    shall have the right to terminate the agreement concluded
                                    between Ufone and the Participant hereby;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="9">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.9</strong>  If a Force Majeure event occurs that directly affects the
                                    ability of Ufone to perform its obligations hereunder, Ufone
                                    shall be entitled to suspend performance of such an obligation
                                    for the duration of the Force Majeure event. Force Majeure
                                    includes acts of God, war, hostilities, riots, civil commotion,
                                    strike, revolution, epidemic, accident, fire, flood,
                                    earthquake, blockade, any decision of the court, tribunal or
                                    authority, PTA or any other cause similar to the kind herein
                                    enumerated or of equivalent force not within the control of
                                    Ufone (including but not limited to reasons attributable to
                                    failure of machinery, Ufone’s telecommunication system, any
                                    hardware or software);
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="10">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.10</strong>  The decision of Ufone in respect of any dispute that may arise
                                    in connection with these Terms and Conditions shall be final
                                    and binding on the Participant;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="11">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.11</strong>  The Customer/Participant acknowledges that under this Campaign
                                    he shall not respond to any calls/SMSs directing to make/send
                                    calls/SMSs to any other number/short code or which are
                                    regarding award of any prize (whether money or in kind) in lieu
                                    of balance transfer or any call. Ignorance of this clause by
                                    the Customer shall not accrue any liabilities/responsibilities
                                    on Ufone including but not limited to liability/responsibility
                                    towards any loss occurred to the Customer/Participant;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="12">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.12</strong>  The language of the Campaign shall be Roman Urdu and/or
                                    English;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="13">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.13</strong>  The Customer who has executed the agreement for availing Ufone
                                    Services against the MSISDN (cell number) under his use shall
                                    be eligible to participate in the Campaign and not otherwise.
                                    However, notwithstanding anything contained herein, the
                                    following shall not be eligible to participate in the Campaign:
                                </p>
                            </li>
                        </li>
                    </li>
                    <ul >
                        <li className="mbrules">
                            <p align="justify">
                                The employees of Ufone;
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Ufone Franchises and Retailers and the employees of its sister
                                concerns;
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                    The spouse, children, parents and siblings (            <strong>“First Degree Relatives”</strong>) of Ufone employees;
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                The registered users of Ufone employee family number; and
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                The contractors, technical service providers and/or professionals
                                and their employees working for this Campaign.
                            </p>
                        </li>
                    </ul>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>
                                    14. COMPLAINT/QUERY HANDLING, DISPUTE RESOLUTION AND ARBITRATION:
                                </strong>
                            </p>
                        </li>
                    </li>
                    <p align="justify">
                        <b>  14.1</b>  The Participant can call at the helpline by dialing 300 round the
                        clock for any complaints regarding the Campaign. The Participant’s call
                        shall be recorded against his CLI for record keeping and in accordance with
                        the instructions given by PTA. Prescribed tariff rates shall be charged for
                        using the helpline services;
                    </p>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <b>14.2</b>  If a Participant requires information regarding the Campaign or
                                    the Trivia, he can access FAQ, Game Rules &amp; detailed
                                    T&amp;C available on Cricwick mobile app and web;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <b>14.3</b>  A Participant can check his rank by accessing the leaderboard
                                    available on the Cricwick mobile app and web;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="3">
                            <li className="mbrules">
                                <p align="justify">
                                <b>14.4</b>  The Campaign and/or the Trivia and these Terms and Conditions
                                    shall be governed by the laws of Pakistan and interpreted in
                                    accordance with laws of Pakistan. If the Participant shall be
                                    of the opinion that he has any right pertaining to the Campaign
                                    and he wishes to invoke such right, the Participant
                                    acknowledges, understands and agrees that such right can only
                                    be invoked through the arbitration which shall be conducted by
                                    the sole arbitrator appointed by Ufone and such arbitration
                                    proceedings shall be conducted in English or Urdu language at
                                    Lahore under the Arbitration Act 1940. Without prejudice to the
                                    above, it is further agreed by the Participant that only the
                                    courts at Lahore shall have the jurisdiction on any matter
                                    relating to the Campaign.
                                </p>
                            </li>
                        </li>
                    </li>
            
                </div>
            )
        } else if (operatorName === "easypaisa")  {
            return (
                <div style={{ fontSize: '14px' }} className="px-3 info">
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>1. INTRODUCTION:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <b>1.1</b>  Telenor Easypaisa Pakistan Private Limited (henceforth                <strong>Telenor Easypaisa</strong>) provides telecommunication services in
                    the Islamic Republic of Pakistan, AJK and Gilgit Baltistan (the                <strong>“Territory”</strong>). Telenor Easypaisa is offering various value
                    added services <strong>(“VAS”) </strong>which also<strong> </strong>includes short messaging service (                <strong>“SMS”</strong>);
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <b>1.2</b>  A new feature (the                <strong>“Master Blaster League”</strong>) in its VAS product
                                    “Cricwick”. The Master Blaster League in its introductory
                                    launch period shall be available for a period of 90 days and
                                    may be extended thereafter. The participation in Master Blaster
                                    League is subject to the successful subscription of Cricwick at PKR 15 weekly & 50 monthly plus tax 
									(Govt. tax of 19.5% is applicable) defined as                <strong>“Charges”</strong> below);
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="3">
                            <li className="mbrules">
                                <p align="justify">
                                <b>1.3</b>  A specially designed marketing campaign                <strong>(</strong>the <strong>“Campaign”) </strong>to promote
                                    its VAS Product “Cricwick” and its newly introduced feature
                                    “Master Blaster League”<strong>. </strong>The Campaign includes
                                    incentives for the Customers subscribing to the Cricwick
                                    and engaging in with the Daily Tasks on the platform, including
                                    the free of cost participation in the Trivia and win a wide
                                    array of cash prizes detailed hereunder. The duration of the
                                    Campaign shall be the introductory period of the Master Blaster
                                    League (i.e. 90 days). Cricwick has created a webpage
                    https://cricwick.net/trivia-faqs/easypaisa (                <strong>“T&amp;C Link”</strong>) and made these Terms and
                                    Conditions (as defined below) available on the Cricwick
                                    mobile app to provide detailed information pertaining to the
                                    Campaign. The Website is publically accessible, whereas the
                                    mobile app shall be accessible to Cricwick subscribers
                                    only;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="4">
                            <li className="mbrules">
                                <p align="justify">
                                <b>1.4</b>  The terms and conditions mentioned herein (                <strong>“Terms and Conditions”</strong>) shall determine the
                                    rights and liabilities of Telenor Easypaisa, Cricwick and the Customer (as defined
                                    below) regarding the Cricwick subscription and also the
                                    Campaign. In order to purchase the subscription to the Telenor Easypaisa
                                    Cricket and consequently also to participate in the Campaign,
                                    the Customer shall accept these Terms and Conditions in their
                                    totality by clicking on the <strong>“Let’s Start”</strong>
                                    button on the Cricwick mobile app and web page. The click
                                    on the button therein, would be for all intents and purposes be
                                    deemed as acceptance on the part of the Customer with these
                                    Terms and Conditions in their totality. The sole consideration
                                    granting the Customer the right to participate in the Campaign
                                    is the subscription to the Cricwick.
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>2. DEFINITIONS AND INTERPRETATIONS:</strong>
                            </p>
                        </li>
                    </li>
                    <p align="justify">
                        <strong>2.1 </strong>
                        <em><strong>Definitions:</strong></em>
                    </p>
                    <p lang="x-none" align="justify">
                        Unless the context requires otherwise, the expressions used in these Terms
                        and Conditions and not defined elsewhere in such Terms and Condition shall
                        have the following meanings assigned to them:
                    </p>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                    <strong>2.1.1 "Advertisement”</strong> or                    <strong>“Advertised by Telenor Easypaisa”</strong> means publication or
                                        advertisement of any information, policy, notice,
                                        intimation, public message or any other communication
                                        regarding the Campaign, collectively or separately, through
                                        any medium including but not limited to digital,
                                        television, radio, outdoor, hoardings/billboards, internet,
                                        cellular and/or print media, SMS Broadcast etc.;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.2 "Terms and Conditions” </strong>means these terms
                                        and conditions;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.3 "Approved modes of communication”</strong> means
                                        any of the modes of communication provided in Telecom
                                        Consumer Protection Regulations, 2009 as amended from time
                                        to time;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.4 "Charges” </strong>means the price for the
                                        subscription of Cricwick (inclusive of taxes) which
                                        shall automatically be charged to the Customer on daily
                                        basis recursively after the Subscription of the Customer to
                                        the Cricwick in accordance with these Terms and
                                        Conditions and it shall continue to be charged until the
                                        Customer unsubscribed from availing the Cricwick
                                        product;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.5 "Connection”</strong> means Post-paid Connection or
                                        Pre-paid Connection issued by Telenor Easypaisa to the Customers;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.6 "Customer”</strong> means the customer (including
                                        natural or legal person) who is availing Telenor Easypaisa Services
                                        through an MSISDN registered and activated validly in his
                                        name at the time of Subscribing to the Cricwick;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.7 "Encryption”</strong> means any technique used by
                                        Telenor Easypaisa to reasonably secure the data, voice transmission or
                                        other communication over the System including but not
                                        limited to prevent eaves dropping over its
                                        telecommunication system except as required by the law or
                                        beyond its reasonable control;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.8 Data</strong><strong>”</strong> means General
                                        Packet Radio Service or Long Term Evolution Service offered
                                        by Telenor Easypaisa to the Customers;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.9 "License”</strong> means the relevant GSM License
                                        issued to Telenor Easypaisa by PTA for provision of Services in the
                                        Territory;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.10 "Master Blaster League” </strong>means a bundle of
                                        daily tasks for Cricwick subscribers to complete and
                                        earn redeemable points;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.11 "MSISDN Number”</strong> means a unique numerical
                                        number assigned against each Connection for availing Telenor Easypaisa
                                        Services;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.12 "Network”</strong> means Telenor Easypaisa’s GSM network as and
                                        where installed throughout the Territory which is run and
                                        supported by the System;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.13 "Participant”</strong> means the Customer who has
                                        elected to participate in the Campaign as per these Terms
                                        and Conditions;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.14 "Parties” </strong>unless the context provides
                                        otherwise means Telenor Easypaisa and the Participant Customers;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.15 "Payables”</strong> or <strong>“Dues”</strong> mean
                                        any payments due against the Customer for availing Telenor Easypaisa
                                        Services as per the relevant agreement thereof;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                    <strong>2.1.16 "Points” or “Pts” </strong><strong>or</strong><strong>“</strong><strong>Scores</strong><strong>”</strong>                    <strong> </strong>means points earned by the Participant
                                        upon answering a Trivia Question on the Cricwick mobile
                                        app or web. The Points shall be used to rank participants
                                        for the Daily and Weekly Top Scorer Prizes;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                    <strong>2.1.17 "Coins</strong><strong>” or “</strong>                    <strong>Coins</strong><strong>”</strong> means a virtual
                                        currency earned by the Participant by completing the daily
                                        tasks on the Cricwick mobile app or web. The Coins may
                                        be redeemed by the subscribers of Cricwick in the form
                                        of pre-paid Top Ups;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.18 "Wallet” </strong>means the virtual wallet where
                                        a participant’s Daily and Weekly winnings shall be credited
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.19 "Post-paid Connection”</strong> means such
                                        Connection for which the Customer, subject to deposit of
                                        any applicable advance or security, pays for the Telenor Easypaisa
                                        Services after availing the Services;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.20 "Pre-paid Connection”</strong> means such
                                        Connection for which the Customer pays for the Telenor Easypaisa
                                        Services in advance before availing such Services;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.21 "PTA”</strong> means Pakistan Telecommunication
                                        Authority or its successor;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.22 "SIM Card”</strong> means subscriber identity
                                        module card corresponding to the unique MSISDN Number
                                        issued to a Customer;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.23 "SMS” </strong>means the Short Messaging Service
                                        provided by Telenor Easypaisa, but the expression “SMS” used in these
                                        terms and condition shall mean either (i) the SMS sent to
                                        customers and subscribers as invitations and / or service
                                        intimations;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.24 "System”</strong> means Telenor Easypaisa’s GSM mobile cellular
                                        system;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.25 "Taxes” or “t”</strong> include all or any taxes,
                                        levies or fees levied/charged by federal government, any
                                        provincial government or any other lawfully competent
                                        authority;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.26 "Territory”</strong> means the territories for
                                        which Telenor Easypaisa is authorized to provide Services under the
                                        License;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                    <strong>2.1.27 "Value Added Services”</strong> or                    <strong>“VAS”</strong> means any value added services
                                        offered by Telenor Easypaisa from time to time to its Customers;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.28 "Telenor Easypaisa Services”</strong> means the services offered
                                        by Telenor Easypaisa from time to time through the System and Network
                                        including mandatory cellular services and optional services
                                        pursuant to the License; and
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.29 "Telenor Easypaisa”</strong> means Telenor Easypaisa Pakistan Private
                                        Limited. (including its successors and assigns) licensed by
                                        PTA to install and operate the Network throughout the
                                        Territory in order to provide the Services.
                                    </p>
                                </li>
                            </li>
                        </li>
                    </li>
                    <p align="justify">
                        <strong>2.2 </strong>
                        <em><strong>Interpretation</strong></em>
                        <strong>s:</strong>
                    </p>
                    <p lang="en-GB" align="justify">
                    <strong>2.2.1 </strong> Headings are included for convenience only and shall not affect the
                        interpretation hereof. Any reference to the singular shall include the
                        plural and vice versa and any reference to one gender shall include all
                        genders;
                    </p>
                    <p lang="en-GB" align="justify">
                    <strong>2.2.2 </strong> The importance of Clauses shall not be determined by their
                        arrangement/order in these Terms and Conditions;
                    </p>
                    <p lang="en-GB" align="justify">
                    <strong>2.2.3 </strong> The words “include”, “includes”, “including” and “included” will be
                        construed without limitation unless inconsistent with the context; and
                    </p>
                    <p lang="en-GB" align="justify">
                    <strong>2.2.4 </strong> The words not expressly defined herein shall bear the dictionary
                        meanings.
                    </p>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>3 CHANGES IN THE TERMS AND CONDITIONS:</strong>
                            </p>
                        </li>
                    </li>
                    <p align="justify">
                        Cricwick and Telenor Easypaisa maintains the absolute right to amend these Terms and Conditions by
                        publishing the amendments and changes on Cricwick official web site.
                        However, the Customer shall be intimated through an SMS from the Cricwick short code
                        or an SMS from Telenor Easypaisa prior to any such amendment or change taking
                        effect.
                    </p>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>4 SHORT CODES:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                    <a name="_GoBack"></a>
                                    <strong>4.1</strong>  Short Code:
                                </p>
                            </li>
                        </li>
                    </li>
                    <p align="justify">
                        The Cricwick Short Code shall be used for sending invitations to participate in the
                        campaign and/or service intimations by Telenor Easypaisa.
                    </p>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>
                                    5. THE MASTER BLASTER LEAGUE; PRODUCT TERMS AND DETAILS
                                </strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>5.1</strong>  The Master Blaster League is a new product feature being made
                                    available for an introductory launch period and shall be
                                    available to the Customers of Telenor Easypaisa via subscribing to Cricwick;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>5.2</strong>  The Customer understands, accepts and agrees that the
                                    subscription to Cricwick will result in the free of cost
                                    participation in the Master Blaster League and clicking on the
                                    “Let’s Play” button shall represent an unconditional acceptance
                                    of these Terms and Conditions in their totality whereof the
                                    link shall be sent to the Customer in an SMS;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="3">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>5.3</strong>  The Master Blaster League consists of a list of Daily Tasks
                                    including but not limited to the following:
                                </p>
                            </li>
                        </li>
                    </li>
                    <ul>
                        <li className="mbrules">
                            <p align="justify">
                                Watch videos on Cricwick
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Share a content on their social media
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Share a referral
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Daily come back bonus
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Open Cricwick app for 5 consecutive days
                            </p>
                        </li>
                    </ul>
                    <li className="mbrules">
                        <li start="4">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>5.4</strong>  The Cricwick subscription price is PKR 15 weekly & 50 monthly plus 19.5% tax, which
                                    shall be charged automatically to the Customer at the start of
                                    each day until such time as the Customer unsubscribes from the
                                    Cricwick platform. When a Customer confirms subscription of
                                    the Cricwick, Customer shall be charged the Charges on a
                                    daily recursive basis in accordance with these Terms and
                                    Conditions. Against such daily Charges the Customer shall avail
                                    all content and features of Cricwick. Customers having
                                    Post-paid connections may use Cricwick or participate in
                                    Master Blaster League, however they are not eligible to claim
                                    any prizes offered in the campaign;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="5">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>5.5</strong>  Customer earning the Coin may redeem them as per the
                                    criteria anytime during the time of his subscription to Telenor Easypaisa
                                    Cricket platform.
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="6">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>5.6</strong>  If any Customer desires to be unregistered as a subscriber of
                                    the Cricwick, he/she shall do it from the Cricwick
                                    mobile app or web;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="7">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>5.7</strong>  If a Customer decides to re-subscribe after unsubscribing from
                                    the Cricwick, he/she can re-subscribe via Cricwick
                                    mobile app or web, and consequently participate in the
                                    Campaign.<strong> </strong>All previously accumulated Points
                                    from the Campaign will also automatically become available for
                                    the re-subscribed Participant if so available for the defined
                                    and relevant period of the Campaign. The re-subscription of a
                                    Customer shall also represent that the Customer has again
                                    unconditionally accepted the Terms and Conditions.
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>6. DETAILS OF CAMPAIGN:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>6.1</strong>  The Customer acknowledges that Telenor Easypaisa has primarily launched this
                                    Campaign to promote Cricwick platform and specifically the
                                    Master Blaster League which has been introduced hereby;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>6.2</strong>  All Customers upon electing to subscribe to the Cricwick by
                                    accepting the Terms and Conditions in the manner prescribed
                                    herein shall become the Participants of the Campaign in in
                                    accordance with these Terms and Conditions;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="3">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>6.3</strong>   To participate in the Campaign, the Customer shall be
                                    registered as a Participant upon the subscription to the Telenor Easypaisa
                                    Cricket consequent to the acceptance of the Terms and
                                    Conditions
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="4">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>6.4</strong>  After registration as a Participant, the Participant shall
                                    become eligible to avail the benefits of the Campaign including
                                    entry in the offered Trivia under the Campaign where the entry
                                    shall be free of cost;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="5">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>6.5</strong>  If a customer fails to pay Cricwick’s subscription charges
                                    i-e PKR 15 weekly & 50 monthly plus 19.5% tax, for 15 consecutive days, he shall not be
                                    eligible to participate in the Trivia offered under Master
                                    Blaster League
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="6">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>6.6</strong>  The Customer/Participant acknowledges that a number of SMS
                                    and/or in-app notifications for the promotion of the Campaign
                                    and service engagement will be sent throughout the duration of
                                    the Campaign;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>7. DURATION OF THE CAMPAIGN:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>7.1</strong>   The duration of the Campaign shall be till the end of the
                                    specified duration and period of the introductory Master
                    Blaster League as determined by Telenor Easypaisa (the                <strong>“Campaign Period”</strong>);
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>7.2</strong>  Telenor Easypaisa or Cricwick may terminate/discontinue the Campaign at any time during
                                    the Campaign Period; however, the Customer/Participant shall be
                                    intimated in accordance with the applicable laws before the
                                    termination/discontinuation date. After the
                                    termination/discontinuation of the Campaign or expiry of
                                    Campaign Period, Telenor Easypaisa bears no obligation towards the
                                    Customer/Participant without any limitation.
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="3">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>7.3</strong>  In the event that the Customer unregisters his subscription of
                                    the Cricwick during the Campaign Period, the participation
                                    in the Campaign shall also stand suspended however, the
                                    accumulated Points and Coins will be retained and the
                                    Customer will be eligible for prizes if applicable for the
                                    period of participation in the Campaign;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>8. OBLIGATIONS OF CUSTOMER/PARTICIPANT:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>8.1</strong>  The Customer/Participant unconditionally accepts these Terms
                                    and Conditions in addition to the terms and conditions agreed
                                    by the Customer in hard document or electronically for availing
                                    Telenor Easypaisa’s cellular services at the time of getting Connection and
                                    shall absolutely comply with them.
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>8.2</strong>  The Customer/Participant shall refrain from any illegal, unfair
                                    or improper actions/deeds/omissions while subscription of the
                                    Cricwick and participating in the Campaign and for getting
                                    the benefits of the Campaign; and in the event of such an
                                    attempt occurring, Telenor Easypaisa shall have all the rights available to
                                    it under these Terms and Conditions, the agreement executed by
                                    the Customer for availing any of Telenor Easypaisa’s Services and the
                                    applicable laws;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>9. MASTER BLASTER PRIZES AND MECHANICS:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>9.1</strong>  The prizes in Master Blaster League shall be the pre-paid TOP
                                    Up of PKR 50 per redemption and Grand Prize of PKR 100,000 to
                                    be distributed among Top 10 scorers in the Master Blaster
                                    League every month. The distribution will be as follows:
                                </p>
                            </li>
                        </li>
                    </li>
                    <ul>
                        <li>
                            <p align="justify">
                                Winner i-e Top Scorer in the Master Blaster League shall receive
                                PKR 20,000
                            </p>
                        </li>
                        <li>
                            <p align="justify">
                                1<sup>st</sup> &amp; 2<sup>nd</sup> Runners Up shall receive PKR 15,000 each
                            </p>
                        </li>
                        <li>
                            <p align="justify">
                                3<sup>rd</sup>, 4<sup>th</sup> &amp; 5<sup>th</sup> Runners Up shall receive PKR
                                10,000 each
                            </p>
                        </li>
                        <li>
                            <p align="justify">
                                6<sup>th</sup> till 9<sup>th</sup> Runners Up shall receive PKR
                                5,000 each
                            </p>
                        </li>
                    </ul>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>9.2</strong>  If 2 or more participants share the same rank, then the prize
                                    for that rank shall be distributed equally among all
                                    participants sharing that rank.
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                <strong>9.3</strong>  The participant MUST complete the daily tasks to earn Coins,
                                    which thereafter shall be redeemed against the prizes of the
                                    Master Blaster League i-e Top Ups;
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                <strong>9.4</strong>   A customer shall only redeem one TOP Up prize daily;
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                <strong>9.5</strong>   1 Coin will be awarded for every 50 points earned by
                                    completing the daily tasks;
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                <strong>9.6</strong>  1 Coin equals to the value of PKR 1. Hence TOP Up of PKR 50
                                    shall only be redeemed upon earning 50 Coins;
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                <strong>9.7</strong>   Point shall be earned by completing the following tasks but not
                                    limited to:
                                </p>
                            </li>
                        </li>
                    </li>
                    <ul>
                        <li className="mbrules">
                            <p align="justify">
                                For every video content on Cricwick watched for a minimum of 30
                                seconds by a participant shall receive upon fulfilling the criteria
                                20 points. Maximum 3 video views shall be counted for the campaign.
                                A total of 60 points may be earned per day;
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                For every Cricwick video shared on participant’s social media
                                shall receive upon fulfilling the criteria 10 points. The points
                                shall be awarded only once the shared link is being clicked /
                                accessed on social media. The points shall only awarded once the
                                shared link is clicked.
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                For every referral / inviting friends &amp; family on Cricwick
                                shall receive upon fulfilling the criteria 100 points. The points
                                shall be awarded only once the invited referral subscribes to the
                                Cricwick platform;
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                For opening the app every day, the customer shall get the points in
                                the following manner:
                            </p>
                        </li>
                    </ul>
                    <ul>
                        <ul>
                            <li className="mbrules">
                                <p align="justify">
                                    Day1 10 Points
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                    Day 2 20 Points
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                    Day 3 30 Points
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                    Day 4 40 Points
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                    Day 5 50 Points
                                </p>
                            </li>
                        </ul>
                    </ul>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>10. TRIVIA PRIZES AND MECHANICS:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>10.1</strong>  Telenor Easypaisa as a part of the Campaign has introduced Trivia Games (the                <strong>“Trivia”</strong>) which is part of the Campaign;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>10.2</strong>  The Participant of his own free will may elect to participate
                                    in the Trivia;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="3">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>10.3</strong>  The Participant may as part of the Campaign to promote the new
                                    feature of Cricwick i-e Master Blaster League, also play
                                    any of the 3 offered Trivia Gaming formats i-e Tez T20, ODI
                                    &amp; Tuk Tuk Test. The Participant/Customer shall not be
                                    charged anything for participating in the Trivia
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="4">
                            <li className="mbrules">
                                <p align="justify">
                                    <strong>10.4 TEZ T20:</strong>
                                </p>
                            </li>
                        </li>
                    </li>
                    <p align="justify">
                        During the Campaign Period, on every day starting from 00:00:00 and ending
                        on 23:59:59, participants MUST answer 10 questions. Daily cash prize of PR
                        20,000 shall be equally distributed among the Top 150 Participants earning
                        maximum Points by answering the Trivia Questions in TEZ T20.
                    </p>
                    <p align="justify">
                        Only 1 (One) TEZ T20 game may be played in a day.
                    </p>
                    <p align="justify">
                        100 Points shall be awarded for every correct answer during the basic play
                        mode. Whereas 300 points shall be awarded for every correct answer during
                        the Power Play mode. Wrong answers will have ZERO points.
                    </p>
                    <p align="justify">
                        Power Play mode may be offered anytime during the game.
                    </p>
                    <p align="justify">
                        Answers MUST be given within the allotted time
                    </p>
                    <ul>
                        <li className="mbrules">
                            <p align="justify">
                                Time allotted for every questions during Basic Game mode shall be
                                10 seconds
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Time allotted for every questions during Power Play mode shall be 7
                                seconds
                            </p>
                        </li>
                    </ul>
                    <p align="justify">
                        <strong>10.5 ODI</strong>
                    </p>
                    <p align="justify">
                        During the Campaign Period, on every day starting from 00:00:00 and ending
                        on 23:59:59, participants MUST answer 30 questions. Daily cash prize of PR
                        30,000 shall be equally distributed among the Top 200 Participants earning
                        maximum Points by answering the Trivia Questions in ODI.
                    </p>
                    <p align="justify">
                        Only 1 (One) ODI game may be played in a day.
                    </p>
                    <p align="justify">
                        200 Points shall be awarded for every correct answer during the basic play
                        mode. Whereas 400 points shall be awarded for every correct answer during
                        the Power Play mode. Wrong answers will have ZERO points.
                    </p>
                    <p align="justify">
                        Power Play mode may be offered anytime during the game.
                    </p>
                    <p align="justify">
                        Answers MUST be given within the allotted time
                    </p>
                    <ul>
                        <li className="mbrules">
                            <p align="justify">
                                Time allotted for every questions during Basic Game mode shall be
                                15 seconds
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Time allotted for every questions during Power Play mode shall be
                                10 seconds
                            </p>
                        </li>
                    </ul>
                    <p align="justify">
                        <strong>10.6 TUK TUK TEST:</strong>
                    </p>
                    <p align="justify">
                        During the Campaign Period, every week starting from Monday 00:00:00 and
                        ending on Sunday 23:59:59, participants MUST play for at least 3 days and
                        answer 30 questions / day. Weekly cash prize of PR 40,000 shall be equally
                        distributed among the Top 200 Participants earning maximum Points by
                        answering the Trivia Questions in TEST.
                    </p>
                    <p align="justify">
                        A participant may play the TEST game for a maximum of 5 days in a week.
                    </p>
                    <p align="justify">
                        100 Points shall be awarded for every correct answer during the basic play
                        mode. Whereas for every 5 (five) correct answers, a streak shall be
                        activated where participants shall get multiples of basic points. Wrong
                        answers will have ZERO points. Streak shall be discontinued once the
                        customer answers the question incorrectly and the points shall revert to
                        basic points i-e 100 points / correct answer.
                    </p>
                    <p align="justify">
                        Streak point calculation example is as follows:
                    </p>
                    <ul>
                        <li className="mbrules">
                            <p align="justify">
                                Question 1 – Question 5 100 Points / correct answer
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Question 6 – Question 10 200 Points / correct answer
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Question 11 – Question 15 300 Points / correct answer
                            </p>
                        </li>
                    </ul>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>11. POWER PLAY MODE</strong>
                            </p>
                        </li>
                    </li>
                    <p align="justify">
                    During the Campaign Period Telenor Easypaisa shall also announce the bonus schemes (    <strong>“Power Play”</strong>) at various times where the participant
                        receives more points than the ones he/she can receive in the Basic Mode.
                        Power Play shall only be offered during TEZ T20 &amp; ODI gaming formats.
                        Time allotted to answer questions during Power Play will be less than the
                        Basic Game mode.
                    </p>
                    <p align="justify">
                        There shall be no Power Play mode in TUK TUK TEST gaming format.
                    </p>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>12. CONDITIONS TO WIN AND RECEIVE THE PRIZES</strong>
                            </p>
                        </li>
                    </li>
                    <p align="justify">
                        <strong>12.1</strong>  The Daily Prize, Weekly Prize, Monthly Grand Prize and TOP Ups shall
                        collectively be referred to as the “Prizes” and separately as the “Prize”;
                    </p>
                    <p align="justify">
                        <strong>12.2</strong>  All cash prizes shall be disbursed to the customer via Jazz Cash or
                        Easy Paisa. A participant must provide his Jazz Cash or Easy Paisa account
                        details to claim the prize;
                    </p>
                    <p align="justify">
                        <strong>12.3</strong>  All Prizes will be subject to applicable Taxes before being handed
                        over to the winning Participant;
                    </p>
                    <p align="justify">
                        <strong>12.4</strong>  Daily &amp; weekly cash winning shall be credited to the participant’s
                        virtual Cricwick Wallet. However, a participant may claim the prize
                        money once his wallet balance touches PKR 1,000;
                    </p>
                    <p align="justify">
                        <strong>12.5</strong>  Cash prizes shall only be disbursed into participant’s designated Jazz
                        Cash or easy Paisa account;
                    </p>
                    <p align="justify">
                        <strong>12.6</strong>  The Participants shall be able to win one type of the Prize once only
                        except the TOP Up which can be redeemed multiple times. The Types of Prizes
                        are given below:
                    </p>
                    <ul >
                        <li className="mbrules">
                            <p align="justify">
                                Daily Prize
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Weekly Prize
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Monthly Grand Prize
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Redeemable TOP Ups
                            </p>
                        </li>
                    </ul>
                    <p align="justify">
                        <strong>12.7 </strong> The Prize Winning Participant shall be required to produce his
                        original CNIC for verification of his antecedents from Telenor Easypaisa’s records and
                        after verification such Participant shall be given the Prize;
                    </p>
                    <p align="justify">
                        <strong>12.8 </strong> If the winning Participant is under 18, then the prize will be awarded
                        to the person whose name the SIM is registered and the prize will be handed
                        over only after verification in accordance with clause <strong>12.5;</strong> 
                    </p>
                    <p align="justify">
                        <strong>12.9 </strong> Telenor Easypaisa or Cricwick reserves the right to disqualify any Participant from receiving
                        any prize(s) if it has reasonable grounds to believe that the Participant
                        breached any provision of the Terms and Conditions and/or the agreement
                        executed for availing Telenor Easypaisa Services;
                    </p>
                    <p align="justify">
                        <strong>12.10 </strong> The Prize winning Participant shall be contacted by Telenor Easypaisa and such
                        Participant shall undertake in writing that he is, the lawful owner of the
                        SIM and MSISDN (cell number), is entitled to receive the Prize and in case
                        of any claimant disputing the receiving of such Prize he shall be
                        responsible for the settlement of such dispute and shall indemnify Telenor Easypaisa in
                        full regarding such dispute (including but not limited to all cost,
                        expenses and reasonable attorney fees incurred by Telenor Easypaisa in relation
                        thereto);
                    </p>
                    <p align="justify">
                        <strong>12.11 </strong> The Prize Winning Participant shall provide all the documents required
                        by Telenor Easypaisa including a Disclaimer stating that he is not disqualified under
                        Clause 13.14 to participate in the Campaign;
                    </p>
                    <p align="justify">
                        <strong>12.12</strong>  The Participant agrees that Telenor Easypaisa or Cricwick may use such photographs, videos and
                        audio recordings taken at the time of Prize distribution, communication
                        happened/exchanged during contact by Telenor Easypaisa for intimation of prize winning
                        and other information including names, surnames etc., in Telenor Easypaisa’s
                        advertisements of the Campaign without any further/prior/specific consent
                        for such purpose. The consent given here and the incorporation of any
                        contents/information in the advertisement of the Campaign shall not entitle
                        the Participant for any remuneration/amount in any manner. If a winning
                        participant later becomes disqualified under these Terms and Conditions to
                        receive the Prize, then any release of advertisement about his winning
                        shall not create any obligation/responsibility on Telenor Easypaisa or Cricwick in favor of such
                        participant either related to the Prize or to any social, financial or
                        other exposure in this regard;
                    </p>
                    <p align="justify">
                        <strong>12.13</strong>  If the notified winner Participant cannot be reached / contacted,
                        disqualified or refuses the Prize or fails to appear to collect it within
                        20 calendar days (the <strong>“Grace Period”</strong>) after the campaign
                        ends, then the claim from winning Participant/runner up shall not be
                        entertained without regard to the reason of such delay/lapse;
                    </p>
                    <p align="justify">
                        <strong>12.14</strong>  The cash Prize Winning Participant must have Jazz Cash or Easy Paisa
                        Account in order to receive the Prize. In case the winner does not have an
                        existing Account, he will be given a period of 15 working days to open Telenor Easypaisa
                        Cash or Easy Paisa account and revert back to Telenor Easypaisa. In case he does not
                        revert back to Telenor Easypaisa in the prescribed time period of 20 days after the
                        campaign ends, it shall be considered the lapse of Grace Period and such
                        Participant shall face the consequences of lapse of Grace Period;
                    </p>
                    <p align="justify">
                        <strong>12.15</strong>  The Prize winner cannot assign or transfer the Prize;
                    </p>
                    <p align="justify">
                        <strong>12.16</strong>  The Participant agrees that Telenor Easypaisa shall not be responsible/liable for
                        any loss, injuries or damages of any kind caused to the Participant by or
                        resulting from the Campaign, the participation in the Campaign, acceptance
                        or receiving the Prizes, or disqualification to receive any Prize including
                        without limitation on account of lapse of Grace Period;
                    </p>
                    <p align="justify">
                        <strong>12.17</strong>  Telenor Easypaisa reserves the right to stop (Pre-mature Stoppage) the Campaign
                        prior to its last date due to any reasons, including but not limited to as
                        mentioned in clause 13.10 herein. In case of Pre-Mature Stoppage, Telenor Easypaisa will
                        publish the results of the Campaign at T&amp;C Link
                        https://cricwick.net/trivia-faqs/easypaisa and shall only give out the prizes
                        won up to the date of Pre-Mature Stoppage;
                    </p>
                    <p align="justify">
                        <strong>12.18</strong>  The Participant understands, agrees and accepts that the decisions
                        made by Telenor Easypaisa or Cricwick shall be final and binding on him.
                    </p>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>13. MISCELLANEOUS:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.1</strong>  Telenor Easypaisa or Cricwick shall not have any liabilities towards the
                                    Customer/Participant after the expiry of Campaign Period except
                                    provided otherwise expressly in the Terms and Conditions. JC
                                    Coins earned during the campaign may be redeemed anytime as
                                    long as the customer stays subscribed to Cricwick.
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.2</strong>  Telenor Easypaisa or Cricwick shall not be responsible for any loss or damage resulting
                                    to the Participant or any third party in any manner in
                                    association and/or connection with the Campaign and
                                    participation therein;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="3">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.3</strong>  Telenor Easypaisa or Cricwick undertakes/gives no warranty (whether express or implied)
                                    whatsoever with respect to the entitlement for any Prize by
                                    mere participation of Participant in the Campaign;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="4">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.4</strong>  Fraud or abuse relating to accrual of Points, may result in
                                    forfeiture/cancellation of such accrued Points as well as
                                    cancellation of a Participant’s eligibility for the Campaign,
                                    suspension of Telenor Easypaisa’s Services to the Participant and
                                    termination of Participant’s Telenor Easypaisa connection; and any decision
                                    by Telenor Easypaisa in this respect shall be final;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="5">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.5</strong>  Without prejudice to Clause 13.4, all questions or disputes
                                    regarding eligibility of the Participant for the Campaign, the
                                    accrual/accumulation of Points and giving of Prizes shall be
                                    resolved by Telenor Easypaisa in its sole discretion and any decision by
                                    Telenor Easypaisa in this respect shall be final;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="6">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.6</strong>  Telenor Easypaisa’s or Cricwick’s failure or delay to enforce a particular term and
                                    condition, right, remedy or penalty shall not constitute as a
                                    waiver of that term and condition, remedy, penalty by Telenor Easypaisa or Cricwick.
                                    Further the enforcement of these Terms and Conditions, right,
                                    remedy or penalty shall not mean the waiver of other terms,
                                    remedies or penalties available to Telenor Easypaisa or Cricwick under this document,
                                    other applicable documents/agreements between Telenor Easypaisa and the
                                    Participant and the relevant laws;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="7">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.7</strong>  Telenor Easypaisa or Cricwick reserves the right to disqualify any Participant from
                                    further participation in the Campaign, if it has reason to
                                    believe that the Participant has in any way violated these
                                    Terms and Conditions, or the terms and conditions of the
                                    agreement executed for availing Telenor Easypaisa Services (which is
                                    mandatory to execute before availing Telenor Easypaisa Services). If a
                                    Participant is availing Telenor Easypaisa Services without execution of any
                                    agreement in this regard, it shall be presumed a breach of
                                    these Terms and Conditions in itself;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="8">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.8</strong>  Unless otherwise expressly stated or implied by context, each
                                    of the Terms and Conditions herein contained shall be severable
                                    and distinct from one another and if any provision of these
                                    Terms and Conditions is held to be invalid, illegal or
                                    unenforceable by a court of competent jurisdiction or any
                                    competent authority, such invalidity, illegality or
                                    unenforceability shall not affect the validity, legality and
                                    enforceability of the remaining provisions. In case any
                                    provision is held to be invalid, illegal or unenforceable by a
                                    competent authority or court, Telenor Easypaisa shall have the right to
                                    amend these Terms and Conditions as may be required as a result
                                    of the order of the competent court or authority. However, in
                                    case the remaining Terms and Conditions cannot survive pursuant
                                    to the order of the competent authority or court, or the
                                    amendment renders these Terms &amp; Condition incapable of
                                    being performed to the extent of obligations with regards to a
                                    Participant/Prize winner, the Participant/Prize winner
                                    understands, accepts and agrees that Telenor Easypaisa in such circumstances
                                    shall have the right to terminate the agreement concluded
                                    between Telenor Easypaisa and the Participant hereby;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="9">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.9</strong>  If a Force Majeure event occurs that directly affects the
                                    ability of Telenor Easypaisa or Cricwick to perform its obligations hereunder, Telenor Easypaisa and/or Cricwick
                                    shall be entitled to suspend performance of such an obligation
                                    for the duration of the Force Majeure event. Force Majeure
                                    includes acts of God, war, hostilities, riots, civil commotion,
                                    strike, revolution, epidemic, accident, fire, flood,
                                    earthquake, blockade, any decision of the court, tribunal or
                                    authority, PTA or any other cause similar to the kind herein
                                    enumerated or of equivalent force not within the control of
                                    Telenor Easypaisa and/or Cricwick (including but not limited to reasons attributable to
                                    failure of machinery, Telenor Easypaisa’s telecommunication system, any
                                    hardware or software);
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="10">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.10</strong>  The decision of Telenor Easypaisa and/or Cricwick in respect of any dispute that may arise
                                    in connection with these Terms and Conditions shall be final
                                    and binding on the Participant;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="11">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.11</strong>  The Customer/Participant acknowledges that under this Campaign
                                    he shall not respond to any calls/SMSs directing to make/send
                                    calls/SMSs to any other number/short code or which are
                                    regarding award of any prize (whether money or in kind) in lieu
                                    of balance transfer or any call. Ignorance of this clause by
                                    the Customer shall not accrue any liabilities/responsibilities
                                    on Telenor Easypaisa including but not limited to liability/responsibility
                                    towards any loss occurred to the Customer/Participant;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="12">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.12</strong>  The language of the Campaign shall be Roman Urdu and/or
                                    English;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="13">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.13</strong>  The Customer who has executed the agreement for availing Telenor Easypaisa
                                    Services against the MSISDN (cell number) under his use shall
                                    be eligible to participate in the Campaign and not otherwise.
                                    However, notwithstanding anything contained herein, the
                                    following shall not be eligible to participate in the Campaign:
                                </p>
                            </li>
                        </li>
                    </li>
                    <li>
                        <li className="mbrules">
                            <p align="justify">
                                The employees of Telenor Easypaisa;
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Telenor Easypaisa Franchises and Retailers and the employees of its sister
                                concerns;
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                    The spouse, children, parents and siblings (            <strong>“First Degree Relatives”</strong>) of Telenor Easypaisa employees;
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                The registered users of Telenor Easypaisa employee family number; and
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                The contractors, technical service providers and/or professionals
                                and their employees working for this Campaign.
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>
                                    14. COMPLAINT/QUERY HANDLING, DISPUTE RESOLUTION AND ARBITRATION:
                                </strong>
                            </p>
                        </li>
                    </li>
                    <p align="justify">
                        <b>  14.1</b>  The Participant can call at the helpline by dialing 345 round the
                        clock for any complaints regarding the Campaign. The Participant’s call
                        shall be recorded against his CLI for record keeping and in accordance with
                        the instructions given by PTA. Prescribed tariff rates shall be charged for
                        using the helpline services;
                    </p>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <b>14.2</b>  If a Participant requires information regarding the Campaign or
                                    the Trivia, he can access FAQ, Game Rules &amp; detailed
                                    T&amp;C available on Cricwick mobile app and web;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <b>14.3</b>  A Participant can check his rank by accessing the leaderboard
                                    available on the Cricwick mobile app and web;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="3">
                            <li className="mbrules">
                                <p align="justify">
                                <b>14.4</b>  The Campaign and/or the Trivia and these Terms and Conditions
                                    shall be governed by the laws of Pakistan and interpreted in
                                    accordance with laws of Pakistan. If the Participant shall be
                                    of the opinion that he has any right pertaining to the Campaign
                                    and he wishes to invoke such right, the Participant
                                    acknowledges, understands and agrees that such right can only
                                    be invoked through the arbitration which shall be conducted by
                                    the sole arbitrator appointed by Telenor Easypaisa and such arbitration
                                    proceedings shall be conducted in English or Urdu language at
                                    Lahore under the Arbitration Act 1940. Without prejudice to the
                                    above, it is further agreed by the Participant that only the
                                    courts at Lahore shall have the jurisdiction on any matter
                                    relating to the Campaign.
                                </p>
                            </li>
                        </li>
                    </li>

                </div>
            )
        } else if (operatorName === "jazz" || operatorName === "mobilink" || operatorName === "warid") {
            return (
                <div style={{ fontSize: '14px' }} className="px-3 info">
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>1. INTRODUCTION:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <b>1.1</b>  Pakistan Mobile Communication Limited (henceforth                <strong>Jazz</strong>) provides telecommunication services in
                    the Islamic Republic of Pakistan, AJK and Gilgit Baltistan (the                <strong>“Territory”</strong>). Jazz is offering various value
                    added services <strong>(“VAS”) </strong>which also<strong> </strong>includes short messaging service (                <strong>“SMS”</strong>);
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <b>1.2</b>  A new feature (the                <strong>“Master Blaster League”</strong>) is being introduced in Jazz Cricket 
                                    “The VAS product”. The Master Blaster League in its introductory
                                    launch period shall be available for a period of 90 days and
                                    may be extended thereafter. The participation in Master Blaster
                                    League is subject to the successful subscription of Jazz Cricket
                                    at PKR 2.38 plus tax (Govt. tax of 19.5% is applicable) per day (defined as                <strong>“Charges”</strong> below);
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="3">
                            <li className="mbrules">
                                <p align="justify">
                                <b>1.3</b>  Jazz is launching a specially designed marketing campaign                <strong>(</strong>the <strong>“Campaign”) </strong>to promote
                                    its VAS Product “Jazz Cricket” and its newly introduced feature
                                    “Master Blaster League”<strong>. </strong>The Campaign includes
                                    incentives for the Customers subscribing to the Jazz Cricket
                                    and engaging in with the Daily Tasks on the platform, including
                                    the free of cost participation in the Trivia and win a wide
                                    array of cash prizes detailed hereunder. The duration of the
                                    Campaign shall be the introductory period of the Master Blaster
                                    League (i.e. 90 days). Jazz has created a webpage
                    https://cricket.jazz.com.pk/termsnconditions/jazz (                <strong>“T&amp;C Link”</strong>) and made these Terms and
                                    Conditions (as defined below) available on the Jazz Cricket
                                    mobile app to provide detailed information pertaining to the
                                    Campaign. The Website is publically accessible, whereas the
                                    mobile app shall be accessible to Jazz Cricket subscribers
                                    only;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="4">
                            <li className="mbrules">
                                <p align="justify">
                                <b>1.4</b>  The terms and conditions mentioned herein (                <strong>“Terms and Conditions”</strong>) shall determine the
                                    rights and liabilities of Jazz and the Customer (as defined
                                    below) regarding the Jazz Cricket subscription and also the
                                    Campaign. In order to purchase the subscription to the Jazz
                                    Cricket and consequently also to participate in the Campaign,
                                    the Customer shall accept these Terms and Conditions in their
                                    totality by clicking on the <strong>“Let’s Start”</strong>
                                    button on the Jazz Cricket mobile app and web page. The click
                                    on the button therein, would be for all intents and purposes be
                                    deemed as acceptance on the part of the Customer with these
                                    Terms and Conditions in their totality. The sole consideration
                                    granting the Customer the right to participate in the Campaign
                                    is the subscription to the Jazz Cricket.
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>2. DEFINITIONS AND INTERPRETATIONS:</strong>
                            </p>
                        </li>
                    </li>
                    <p align="justify">
                        <strong>2.1 </strong>
                        <em><strong>Definitions:</strong></em>
                    </p>
                    <p lang="x-none" align="justify">
                        Unless the context requires otherwise, the expressions used in these Terms
                        and Conditions and not defined elsewhere in such Terms and Condition shall
                        have the following meanings assigned to them:
                    </p>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                    <strong>2.1.1 "Advertisement”</strong> or                    <strong>“Advertised by Jazz”</strong> means publication or
                                        advertisement of any information, policy, notice,
                                        intimation, public message or any other communication
                                        regarding the Campaign, collectively or separately, through
                                        any medium including but not limited to digital,
                                        television, radio, outdoor, hoardings/billboards, internet,
                                        cellular and/or print media, SMS Broadcast etc.;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.2 "Terms and Conditions” </strong>means these terms
                                        and conditions;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.3 "Approved modes of communication”</strong> means
                                        any of the modes of communication provided in Telecom
                                        Consumer Protection Regulations, 2009 as amended from time
                                        to time;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.4 "Charges” </strong>means the price for the
                                        subscription of Jazz Cricket (inclusive of taxes) which
                                        shall automatically be charged to the Customer on daily
                                        basis recursively after the Subscription of the Customer to
                                        the Jazz Cricket in accordance with these Terms and
                                        Conditions and it shall continue to be charged until the
                                        Customer unsubscribed from availing the Jazz Cricket
                                        product;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.5 "Connection”</strong> means Post-paid Connection or
                                        Pre-paid Connection issued by Jazz to the Customers;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.6 "Customer”</strong> means the customer (including
                                        natural or legal person) who is availing Jazz Services
                                        through an MSISDN registered and activated validly in his
                                        name at the time of Subscribing to the Jazz Cricket;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.7 "Encryption”</strong> means any technique used by
                                        Jazz to reasonably secure the data, voice transmission or
                                        other communication over the System including but not
                                        limited to prevent eaves dropping over its
                                        telecommunication system except as required by the law or
                                        beyond its reasonable control;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.8 Data</strong><strong>”</strong> means General
                                        Packet Radio Service or Long Term Evolution Service offered
                                        by Jazz to the Customers;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.9 "License”</strong> means the relevant GSM License
                                        issued to Jazz by PTA for provision of Services in the
                                        Territory;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.10 "Master Blaster League” </strong>means a bundle of
                                        daily tasks for Jazz Cricket subscribers to complete and
                                        earn redeemable points;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.11 "MSISDN Number”</strong> means a unique numerical
                                        number assigned against each Connection for availing Jazz
                                        Services;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.12 "Network”</strong> means Jazz’s GSM network as and
                                        where installed throughout the Territory which is run and
                                        supported by the System;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.13 "Participant”</strong> means the Customer who has
                                        elected to participate in the Campaign as per these Terms
                                        and Conditions;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.14 "Parties” </strong>unless the context provides
                                        otherwise means Jazz and the Participant Customers;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.15 "Payables”</strong> or <strong>“Dues”</strong> mean
                                        any payments due against the Customer for availing Jazz
                                        Services as per the relevant agreement thereof;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                    <strong>2.1.16 "Points” or “Pts” </strong><strong>or</strong><strong>“</strong><strong>Scores</strong><strong>”</strong>                    <strong> </strong>means points earned by the Participant
                                        upon answering a Trivia Question on the Jazz Cricket mobile
                                        app or web. The Points shall be used to rank participants
                                        for the Daily and Weekly Top Scorer Prizes;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                    <strong>2.1.17 "Coins</strong><strong>” or “</strong>                    <strong>Coins</strong><strong>”</strong> means a virtual
                                        currency earned by the Participant by completing the daily
                                        tasks on the Jazz Cricket mobile app or web. The Coins may
                                        be redeemed by the subscribers of Jazz Cricket in the form
                                        of pre-paid Top Ups;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.18 "Wallet” </strong>means the virtual wallet where
                                        a participant’s Daily and Weekly winnings shall be credited
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.19 "Post-paid Connection”</strong> means such
                                        Connection for which the Customer, subject to deposit of
                                        any applicable advance or security, pays for the Jazz
                                        Services after availing the Services;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.20 "Pre-paid Connection”</strong> means such
                                        Connection for which the Customer pays for the Jazz
                                        Services in advance before availing such Services;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.21 "PTA”</strong> means Pakistan Telecommunication
                                        Authority or its successor;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.22 "SIM Card”</strong> means subscriber identity
                                        module card corresponding to the unique MSISDN Number
                                        issued to a Customer;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.23 "SMS” </strong>means the Short Messaging Service
                                        provided by Jazz, but the expression “SMS” used in these
                                        terms and condition shall mean either (i) the SMS sent to
                                        customers and subscribers as invitations and / or service
                                        intimations;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.24 "System”</strong> means Jazz’s GSM mobile cellular
                                        system;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.25 "Taxes” or “t”</strong> include all or any taxes,
                                        levies or fees levied/charged by federal government, any
                                        provincial government or any other lawfully competent
                                        authority;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.26 "Territory”</strong> means the territories for
                                        which Jazz is authorized to provide Services under the
                                        License;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                    <strong>2.1.27 "Value Added Services”</strong> or                    <strong>“VAS”</strong> means any value added services
                                        offered by Jazz from time to time to its Customers;
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.28 "Jazz Services”</strong> means the services offered
                                        by Jazz from time to time through the System and Network
                                        including mandatory cellular services and optional services
                                        pursuant to the License; and
                                    </p>
                                </li>
                                <li className="mbrules">
                                    <p lang="x-none" align="justify">
                                        <strong>2.1.29 "Jazz”</strong> means Pak Telecom Mobile
                                        Limited. (including its successors and assigns) licensed by
                                        PTA to install and operate the Network throughout the
                                        Territory in order to provide the Services.
                                    </p>
                                </li>
                            </li>
                        </li>
                    </li>
                    <p align="justify">
                        <strong>2.2 </strong>
                        <em><strong>Interpretation</strong></em>
                        <strong>s:</strong>
                    </p>
                    <p lang="en-GB" align="justify">
                    <strong>2.2.1 </strong> Headings are included for convenience only and shall not affect the
                        interpretation hereof. Any reference to the singular shall include the
                        plural and vice versa and any reference to one gender shall include all
                        genders;
                    </p>
                    <p lang="en-GB" align="justify">
                    <strong>2.2.2 </strong> The importance of Clauses shall not be determined by their
                        arrangement/order in these Terms and Conditions;
                    </p>
                    <p lang="en-GB" align="justify">
                    <strong>2.2.3 </strong> The words “include”, “includes”, “including” and “included” will be
                        construed without limitation unless inconsistent with the context; and
                    </p>
                    <p lang="en-GB" align="justify">
                    <strong>2.2.4 </strong> The words not expressly defined herein shall bear the dictionary
                        meanings.
                    </p>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>3 CHANGES IN THE TERMS AND CONDITIONS:</strong>
                            </p>
                        </li>
                    </li>
                    <p align="justify">
                        Jazz maintains the absolute right to amend these Terms and Conditions by
                        publishing the amendments and changes on Jazz Cricket official web site.
                        However, the Customer shall be intimated through an SMS from the Jazz Cricket short code
                        or an SMS from Jazz prior to any such amendment or change taking
                        effect.
                    </p>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>4 SHORT CODES:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                    <a name="_GoBack"></a>
                                    <strong>4.1</strong>  Short Code:
                                </p>
                            </li>
                        </li>
                    </li>
                    <p align="justify">
                        The Jazz Cricket Short Code shall be used for sending invitations to participate in the
                        campaign and/or service intimations by Jazz.
                    </p>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>
                                    5. THE MASTER BLASTER LEAGUE; PRODUCT TERMS AND DETAILS
                                </strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>5.1</strong>  The Master Blaster League is a new product feature being made
                                    available for an introductory launch period and shall be
                                    available to the Customers of Jazz via subscribing to Jazz
                                    Cricket;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>5.2</strong>  The Customer understands, accepts and agrees that the
                                    subscription to Jazz Cricket will result in the free of cost
                                    participation in the Master Blaster League and clicking on the
                                    “Let’s Play” button shall represent an unconditional acceptance
                                    of these Terms and Conditions in their totality whereof the
                                    link shall be sent to the Customer in an SMS;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="3">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>5.3</strong>  The Master Blaster League consists of a list of Daily Tasks
                                    including but not limited to the following:
                                </p>
                            </li>
                        </li>
                    </li>
                    <ul>
                        <li className="mbrules">
                            <p align="justify">
                                Watch videos on Jazz Cricket
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Share a content on their social media
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Share a referral
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Daily come back bonus
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Open Jazz Cricket app for 5 consecutive days
                            </p>
                        </li>
                    </ul>
                    <li className="mbrules">
                        <li start="4">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>5.4</strong>  The Jazz Cricket subscription price is PKR 2.38 plus 19.5% tax, which
                                    shall be charged automatically to the Customer at the start of
                                    each day until such time as the Customer unsubscribes from the
                                    Jazz Cricket platform. When a Customer confirms subscription of
                                    the Jazz Cricket, Customer shall be charged the Charges on a
                                    daily recursive basis in accordance with these Terms and
                                    Conditions. Against such daily Charges the Customer shall avail
                                    all content and features of Jazz Cricket. Customers having
                                    Post-paid connections may use Jazz Cricket or participate in
                                    Master Blaster League, however they are not eligible to claim
                                    any prizes offered in the campaign;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="5">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>5.5</strong>  Customer earning the Coin may redeem them as per the
                                    criteria anytime during the time of his subscription to Jazz
                                    Cricket platform.
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="6">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>5.6</strong>  If any Customer desires to be unregistered as a subscriber of
                                    the Jazz Cricket, he/she shall do it from the Jazz Cricket
                                    mobile app or web;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="7">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>5.7</strong>  If a Customer decides to re-subscribe after unsubscribing from
                                    the Jazz Cricket, he/she can re-subscribe via Jazz Cricket
                                    mobile app or web, and consequently participate in the
                                    Campaign.<strong> </strong>All previously accumulated Points
                                    from the Campaign will also automatically become available for
                                    the re-subscribed Participant if so available for the defined
                                    and relevant period of the Campaign. The re-subscription of a
                                    Customer shall also represent that the Customer has again
                                    unconditionally accepted the Terms and Conditions.
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>6. DETAILS OF CAMPAIGN:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>6.1</strong>  The Customer acknowledges that Jazz has primarily launched this
                                    Campaign to promote Jazz Cricket platform and specifically the
                                    Master Blaster League which has been introduced hereby;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>6.2</strong>  All Customers upon electing to subscribe to the Jazz Cricket by
                                    accepting the Terms and Conditions in the manner prescribed
                                    herein shall become the Participants of the Campaign in in
                                    accordance with these Terms and Conditions;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="3">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>6.3</strong>   To participate in the Campaign, the Customer shall be
                                    registered as a Participant upon the subscription to the Jazz
                                    Cricket consequent to the acceptance of the Terms and
                                    Conditions
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="4">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>6.4</strong>  After registration as a Participant, the Participant shall
                                    become eligible to avail the benefits of the Campaign including
                                    entry in the offered Trivia under the Campaign where the entry
                                    shall be free of cost;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="5">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>6.5</strong>  If a customer fails to pay Jazz Cricket’s subscription charges
                                    i-e PKR 2.38 plus 19.5% tax, for 15 consecutive days, he shall not be
                                    eligible to participate in the Trivia offered under Master
                                    Blaster League
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="6">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>6.6</strong>  The Customer/Participant acknowledges that a number of SMS
                                    and/or in-app notifications for the promotion of the Campaign
                                    and service engagement will be sent throughout the duration of
                                    the Campaign;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>7. DURATION OF THE CAMPAIGN:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>7.1</strong>   The duration of the Campaign shall be till the end of the
                                    specified duration and period of the introductory Master
                    Blaster League as determined by Jazz (the                <strong>“Campaign Period”</strong>);
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>7.2</strong>  Jazz may terminate/discontinue the Campaign at any time during
                                    the Campaign Period; however, the Customer/Participant shall be
                                    intimated in accordance with the applicable laws before the
                                    termination/discontinuation date. After the
                                    termination/discontinuation of the Campaign or expiry of
                                    Campaign Period, Jazz bears no obligation towards the
                                    Customer/Participant without any limitation.
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="3">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>7.3</strong>  In the event that the Customer unregisters his subscription of
                                    the Jazz Cricket during the Campaign Period, the participation
                                    in the Campaign shall also stand suspended however, the
                                    accumulated Points and Coins will be retained and the
                                    Customer will be eligible for prizes if applicable for the
                                    period of participation in the Campaign;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>8. OBLIGATIONS OF CUSTOMER/PARTICIPANT:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>8.1</strong>  The Customer/Participant unconditionally accepts these Terms
                                    and Conditions in addition to the terms and conditions agreed
                                    by the Customer in hard document or electronically for availing
                                    Jazz’s cellular services at the time of getting Connection and
                                    shall absolutely comply with them.
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>8.2</strong>  The Customer/Participant shall refrain from any illegal, unfair
                                    or improper actions/deeds/omissions while subscription of the
                                    Jazz Cricket and participating in the Campaign and for getting
                                    the benefits of the Campaign; and in the event of such an
                                    attempt occurring, Jazz shall have all the rights available to
                                    it under these Terms and Conditions, the agreement executed by
                                    the Customer for availing any of Jazz’s Services and the
                                    applicable laws;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>9. MASTER BLASTER PRIZES AND MECHANICS:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>9.1</strong>  The prizes in Master Blaster League shall be the pre-paid TOP
                                    Up of PKR 50 per redemption and Grand Prize of PKR 300,000 to
                                    be distributed among Top 50 scorers in the Master Blaster
                                    League every month. The distribution will be as follows:
                                </p>
                            </li>
                        </li>
                    </li>
                    <ul>
                        <li>
                            <p align="justify">
                                Winner i-e Top Scorer in the Master Blaster League shall receive
                                PKR 20,000
                            </p>
                        </li>
                        <li>
                            <p align="justify">
                                1<sup>st</sup> &amp; 2<sup>nd</sup> Runners Up shall receive PKR 15,000 each
                            </p>
                        </li>
                        <li>
                            <p align="justify">
                                3<sup>rd</sup>, 4<sup>th</sup> &amp; 5<sup>th</sup> Runners Up shall receive PKR
                                10,000 each
                            </p>
                        </li>
                        <li>
                            <p align="justify">
                                6<sup>th</sup> till 9<sup>th</sup> Runners Up shall receive PKR
                                5,000 each
                            </p>
                        </li>
                    </ul>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>9.2</strong>  If 2 or more participants share the same rank, then the prize
                                    for that rank shall be distributed equally among all
                                    participants sharing that rank.
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                <strong>9.3</strong>  The participant MUST complete the daily tasks to earn Coins,
                                    which thereafter shall be redeemed against the prizes of the
                                    Master Blaster League i-e Top Ups;
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                <strong>9.4</strong>   A customer shall only redeem one TOP Up prize daily;
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                <strong>9.5</strong>   1 Coin will be awarded for every 50 points earned by
                                    completing the daily tasks;
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                <strong>9.6</strong>  1 Coin equals to the value of PKR 1. Hence TOP Up of PKR 50
                                    shall only be redeemed upon earning 50 Coins;
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                <strong>9.7</strong>   Point shall be earned by completing the following tasks but not
                                    limited to:
                                </p>
                            </li>
                        </li>
                    </li>
                    <ul>
                        <li className="mbrules">
                            <p align="justify">
                                For every video content on Jazz Cricket watched for a minimum of 30
                                seconds by a participant shall receive upon fulfilling the criteria
                                20 points. Maximum 3 video views shall be counted for the campaign.
                                A total of 60 points may be earned per day;
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                For every Jazz Cricket video shared on participant’s social media
                                shall receive upon fulfilling the criteria 10 points. The points
                                shall be awarded only once the shared link is being clicked /
                                accessed on social media. The points shall only awarded once the
                                shared link is clicked.
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                For every referral / inviting friends &amp; family on Jazz Cricket
                                shall receive upon fulfilling the criteria 100 points. The points
                                shall be awarded only once the invited referral subscribes to the
                                Jazz Cricket platform;
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                For opening the app every day, the customer shall get the points in
                                the following manner:
                            </p>
                        </li>
                    </ul>
                    <ul>
                        <ul>
                            <li className="mbrules">
                                <p align="justify">
                                    Day1 10 Points
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                    Day 2 20 Points
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                    Day 3 30 Points
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                    Day 4 40 Points
                                </p>
                            </li>
                            <li className="mbrules">
                                <p align="justify">
                                    Day 5 50 Points
                                </p>
                            </li>
                        </ul>
                    </ul>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>10. TRIVIA PRIZES AND MECHANICS:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>10.1</strong>  Jazz as a part of the Campaign has introduced Trivia Games (the                <strong>“Trivia”</strong>) which is part of the Campaign;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>10.2</strong>  The Participant of his own free will may elect to participate
                                    in the Trivia;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="3">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>10.3</strong>  The Participant may as part of the Campaign to promote the new
                                    feature of Jazz Cricket i-e Master Blaster League, also play
                                    any of the 3 offered Trivia Gaming formats i-e Tez T20, ODI
                                    &amp; Tuk Tuk Test. The Participant/Customer shall not be
                                    charged anything for participating in the Trivia
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="4">
                            <li className="mbrules">
                                <p align="justify">
                                    <strong>10.4 TEZ T20:</strong>
                                </p>
                            </li>
                        </li>
                    </li>
                    <p align="justify">
                        During the Campaign Period, on every day starting from 00:00:00 and ending
                        on 23:59:59, participants MUST answer 10 questions. Daily cash prize of PR
                        20,000 shall be equally distributed among the Top 150 Participants earning
                        maximum Points by answering the Trivia Questions in TEZ T20.
                    </p>
                    <p align="justify">
                        Only 1 (One) TEZ T20 game may be played in a day.
                    </p>
                    <p align="justify">
                        100 Points shall be awarded for every correct answer during the basic play
                        mode. Whereas 300 points shall be awarded for every correct answer during
                        the Power Play mode. Wrong answers will have ZERO points.
                    </p>
                    <p align="justify">
                        Power Play mode may be offered anytime during the game.
                    </p>
                    <p align="justify">
                        Answers MUST be given within the allotted time
                    </p>
                    <ul>
                        <li className="mbrules">
                            <p align="justify">
                                Time allotted for every questions during Basic Game mode shall be
                                10 seconds
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Time allotted for every questions during Power Play mode shall be 7
                                seconds
                            </p>
                        </li>
                    </ul>
                    <p align="justify">
                        <strong>10.5 ODI</strong>
                    </p>
                    <p align="justify">
                        During the Campaign Period, on every day starting from 00:00:00 and ending
                        on 23:59:59, participants MUST answer 30 questions. Daily cash prize of PR
                        30,000 shall be equally distributed among the Top 200 Participants earning
                        maximum Points by answering the Trivia Questions in ODI.
                    </p>
                    <p align="justify">
                        Only 1 (One) ODI game may be played in a day.
                    </p>
                    <p align="justify">
                        200 Points shall be awarded for every correct answer during the basic play
                        mode. Whereas 400 points shall be awarded for every correct answer during
                        the Power Play mode. Wrong answers will have ZERO points.
                    </p>
                    <p align="justify">
                        Power Play mode may be offered anytime during the game.
                    </p>
                    <p align="justify">
                        Answers MUST be given within the allotted time
                    </p>
                    <ul>
                        <li className="mbrules">
                            <p align="justify">
                                Time allotted for every questions during Basic Game mode shall be
                                15 seconds
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Time allotted for every questions during Power Play mode shall be
                                10 seconds
                            </p>
                        </li>
                    </ul>
                    <p align="justify">
                        <strong>10.6 TUK TUK TEST:</strong>
                    </p>
                    <p align="justify">
                        During the Campaign Period, every week starting from Monday 00:00:00 and
                        ending on Sunday 23:59:59, participants MUST play for at least 3 days and
                        answer 30 questions / day. Weekly cash prize of PR 40,000 shall be equally
                        distributed among the Top 200 Participants earning maximum Points by
                        answering the Trivia Questions in TEST.
                    </p>
                    <p align="justify">
                        A participant may play the TEST game for a maximum of 5 days in a week.
                    </p>
                    <p align="justify">
                        100 Points shall be awarded for every correct answer during the basic play
                        mode. Whereas for every 5 (five) correct answers, a streak shall be
                        activated where participants shall get multiples of basic points. Wrong
                        answers will have ZERO points. Streak shall be discontinued once the
                        customer answers the question incorrectly and the points shall revert to
                        basic points i-e 100 points / correct answer.
                    </p>
                    <p align="justify">
                        Streak point calculation example is as follows:
                    </p>
                    <ul>
                        <li className="mbrules">
                            <p align="justify">
                                Question 1 – Question 5 100 Points / correct answer
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Question 6 – Question 10 200 Points / correct answer
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Question 11 – Question 15 300 Points / correct answer
                            </p>
                        </li>
                    </ul>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>11. POWER PLAY MODE</strong>
                            </p>
                        </li>
                    </li>
                    <p align="justify">
                    During the Campaign Period Jazz shall also announce the bonus schemes (    <strong>“Power Play”</strong>) at various times where the participant
                        receives more points than the ones he/she can receive in the Basic Mode.
                        Power Play shall only be offered during TEZ T20 &amp; ODI gaming formats.
                        Time allotted to answer questions during Power Play will be less than the
                        Basic Game mode.
                    </p>
                    <p align="justify">
                        There shall be no Power Play mode in TUK TUK TEST gaming format.
                    </p>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>12. CONDITIONS TO WIN AND RECEIVE THE PRIZES</strong>
                            </p>
                        </li>
                    </li>
                    <p align="justify">
                        <strong>12.1</strong>  The Daily Prize, Weekly Prize, Monthly Grand Prize and TOP Ups shall
                        collectively be referred to as the “Prizes” and separately as the “Prize”;
                    </p>
                    <p align="justify">
                        <strong>12.2</strong>  All cash prizes shall be disbursed to the customer via Jazz Cash or
                        Easy Paisa. A participant must provide his Jazz Cash or Easy Paisa account
                        details to claim the prize;
                    </p>
                    <p align="justify">
                        <strong>12.3</strong>  All Prizes will be subject to applicable Taxes before being handed
                        over to the winning Participant;
                    </p>
                    <p align="justify">
                        <strong>12.4</strong>  Daily &amp; weekly cash winning shall be credited to the participant’s
                        virtual Jazz Cricket Wallet. However, a participant may claim the prize
                        money once his wallet balance touches PKR 1,000;
                    </p>
                    <p align="justify">
                        <strong>12.5</strong>  Cash prizes shall only be disbursed into participant’s designated Jazz
                        Cash or easy Paisa account;
                    </p>
                    <p align="justify">
                        <strong>12.6</strong>  The Participants shall be able to win one type of the Prize once only
                        except the TOP Up which can be redeemed multiple times. The Types of Prizes
                        are given below:
                    </p>
                    <ul >
                        <li className="mbrules">
                            <p align="justify">
                                Daily Prize
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Weekly Prize
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Monthly Grand Prize
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Redeemable TOP Ups
                            </p>
                        </li>
                    </ul>
                    <p align="justify">
                        <strong>12.5 </strong> The Prize Winning Participant shall be required to produce his
                        original CNIC for verification of his antecedents from Jazz’s records and
                        after verification such Participant shall be given the Prize;
                    </p>
                    <p align="justify">
                        <strong>12.6 </strong> If the winning Participant is under 18, then the prize will be awarded
                        to the person whose name the SIM is registered and the prize will be handed
                        over only after verification in accordance with clause <strong>12.5;</strong> 
                    </p>
                    <p align="justify">
                        <strong>12.7 </strong> Jazz reserves the right to disqualify any Participant from receiving
                        any prize(s) if it has reasonable grounds to believe that the Participant
                        breached any provision of the Terms and Conditions and/or the agreement
                        executed for availing Jazz Services;
                    </p>
                    <p align="justify">
                        <strong>12.8 </strong> The Prize winning Participant shall be contacted by Jazz and such
                        Participant shall undertake in writing that he is, the lawful owner of the
                        SIM and MSISDN (cell number), is entitled to receive the Prize and in case
                        of any claimant disputing the receiving of such Prize he shall be
                        responsible for the settlement of such dispute and shall indemnify Jazz in
                        full regarding such dispute (including but not limited to all cost,
                        expenses and reasonable attorney fees incurred by Jazz in relation
                        thereto);
                    </p>
                    <p align="justify">
                        <strong>12.9 </strong> The Prize Winning Participant shall provide all the documents required
                        by Jazz including a Disclaimer stating that he is not disqualified under
                        Clause 13.14 to participate in the Campaign;
                    </p>
                    <p align="justify">
                        <strong>12.10</strong>  The Participant agrees that Jazz may use such photographs, videos and
                        audio recordings taken at the time of Prize distribution, communication
                        happened/exchanged during contact by Jazz for intimation of prize winning
                        and other information including names, surnames etc., in Jazz’s
                        advertisements of the Campaign without any further/prior/specific consent
                        for such purpose. The consent given here and the incorporation of any
                        contents/information in the advertisement of the Campaign shall not entitle
                        the Participant for any remuneration/amount in any manner. If a winning
                        participant later becomes disqualified under these Terms and Conditions to
                        receive the Prize, then any release of advertisement about his winning
                        shall not create any obligation/responsibility on Jazz in favor of such
                        participant either related to the Prize or to any social, financial or
                        other exposure in this regard;
                    </p>
                    <p align="justify">
                        <strong>12.11</strong>  If the notified winner Participant cannot be reached / contacted,
                        disqualified or refuses the Prize or fails to appear to collect it within
                        20 calendar days (the <strong>“Grace Period”</strong>) after the campaign
                        ends, then the claim from winning Participant/runner up shall not be
                        entertained without regard to the reason of such delay/lapse;
                    </p>
                    <p align="justify">
                        <strong>12.12</strong>  The cash Prize Winning Participant must have Jazz Cash or Easy Paisa
                        Account in order to receive the Prize. In case the winner does not have an
                        existing Account, he will be given a period of 15 working days to open Jazz
                        Cash or Easy Paisa account and revert back to Jazz. In case he does not
                        revert back to Jazz in the prescribed time period of 20 days after the
                        campaign ends, it shall be considered the lapse of Grace Period and such
                        Participant shall face the consequences of lapse of Grace Period;
                    </p>
                    <p align="justify">
                        <strong>12.13</strong>  The Prize winner cannot assign or transfer the Prize;
                    </p>
                    <p align="justify">
                        <strong>12.14</strong>  The Participant agrees that Jazz shall not be responsible/liable for
                        any loss, injuries or damages of any kind caused to the Participant by or
                        resulting from the Campaign, the participation in the Campaign, acceptance
                        or receiving the Prizes, or disqualification to receive any Prize including
                        without limitation on account of lapse of Grace Period;
                    </p>
                    <p align="justify">
                        <strong>12.15</strong>  Jazz reserves the right to stop (Pre-mature Stoppage) the Campaign
                        prior to its last date due to any reasons, including but not limited to as
                        mentioned in clause 13.10 herein. In case of Pre-Mature Stoppage, Jazz will
                        publish the results of the Campaign at T&amp;C Link
                        https://cricket.jazz.com.pk/termsnconditions/jazz and shall only give out the prizes
                        won up to the date of Pre-Mature Stoppage;
                    </p>
                    <p align="justify">
                        <strong>12.16</strong>  The Participant understands, agrees and accepts that the decisions
                        made by Jazz shall be final and binding on him.
                    </p>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>13. MISCELLANEOUS:</strong>
                            </p>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.1</strong>  Jazz shall not have any liabilities towards the
                                    Customer/Participant after the expiry of Campaign Period except
                                    provided otherwise expressly in the Terms and Conditions. JC
                                    Coins earned during the campaign may be redeemed anytime as
                                    long as the customer stays subscribed to Jazz Cricket.
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.2</strong>  Jazz shall not be responsible for any loss or damage resulting
                                    to the Participant or any third party in any manner in
                                    association and/or connection with the Campaign and
                                    participation therein;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="3">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.3</strong>  Jazz undertakes/gives no warranty (whether express or implied)
                                    whatsoever with respect to the entitlement for any Prize by
                                    mere participation of Participant in the Campaign;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="4">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.4</strong>  Fraud or abuse relating to accrual of Points, may result in
                                    forfeiture/cancellation of such accrued Points as well as
                                    cancellation of a Participant’s eligibility for the Campaign,
                                    suspension of Jazz’s Services to the Participant and
                                    termination of Participant’s Jazz connection; and any decision
                                    by Jazz in this respect shall be final;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="5">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.5</strong>  Without prejudice to Clause 13.4, all questions or disputes
                                    regarding eligibility of the Participant for the Campaign, the
                                    accrual/accumulation of Points and giving of Prizes shall be
                                    resolved by Jazz in its sole discretion and any decision by
                                    Jazz in this respect shall be final;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="6">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.6</strong>  Jazz’s failure or delay to enforce a particular term and
                                    condition, right, remedy or penalty shall not constitute as a
                                    waiver of that term and condition, remedy, penalty by Jazz.
                                    Further the enforcement of these Terms and Conditions, right,
                                    remedy or penalty shall not mean the waiver of other terms,
                                    remedies or penalties available to Jazz under this document,
                                    other applicable documents/agreements between Jazz and the
                                    Participant and the relevant laws;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="7">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.7</strong>  Jazz reserves the right to disqualify any Participant from
                                    further participation in the Campaign, if it has reason to
                                    believe that the Participant has in any way violated these
                                    Terms and Conditions, or the terms and conditions of the
                                    agreement executed for availing Jazz Services (which is
                                    mandatory to execute before availing Jazz Services). If a
                                    Participant is availing Jazz Services without execution of any
                                    agreement in this regard, it shall be presumed a breach of
                                    these Terms and Conditions in itself;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="8">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.8</strong>  Unless otherwise expressly stated or implied by context, each
                                    of the Terms and Conditions herein contained shall be severable
                                    and distinct from one another and if any provision of these
                                    Terms and Conditions is held to be invalid, illegal or
                                    unenforceable by a court of competent jurisdiction or any
                                    competent authority, such invalidity, illegality or
                                    unenforceability shall not affect the validity, legality and
                                    enforceability of the remaining provisions. In case any
                                    provision is held to be invalid, illegal or unenforceable by a
                                    competent authority or court, Jazz shall have the right to
                                    amend these Terms and Conditions as may be required as a result
                                    of the order of the competent court or authority. However, in
                                    case the remaining Terms and Conditions cannot survive pursuant
                                    to the order of the competent authority or court, or the
                                    amendment renders these Terms &amp; Condition incapable of
                                    being performed to the extent of obligations with regards to a
                                    Participant/Prize winner, the Participant/Prize winner
                                    understands, accepts and agrees that Jazz in such circumstances
                                    shall have the right to terminate the agreement concluded
                                    between Jazz and the Participant hereby;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="9">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.9</strong>  If a Force Majeure event occurs that directly affects the
                                    ability of Jazz to perform its obligations hereunder, Jazz
                                    shall be entitled to suspend performance of such an obligation
                                    for the duration of the Force Majeure event. Force Majeure
                                    includes acts of God, war, hostilities, riots, civil commotion,
                                    strike, revolution, epidemic, accident, fire, flood,
                                    earthquake, blockade, any decision of the court, tribunal or
                                    authority, PTA or any other cause similar to the kind herein
                                    enumerated or of equivalent force not within the control of
                                    Jazz (including but not limited to reasons attributable to
                                    failure of machinery, Jazz’s telecommunication system, any
                                    hardware or software);
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="10">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.10</strong>  The decision of Jazz in respect of any dispute that may arise
                                    in connection with these Terms and Conditions shall be final
                                    and binding on the Participant;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="11">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.11</strong>  The Customer/Participant acknowledges that under this Campaign
                                    he shall not respond to any calls/SMSs directing to make/send
                                    calls/SMSs to any other number/short code or which are
                                    regarding award of any prize (whether money or in kind) in lieu
                                    of balance transfer or any call. Ignorance of this clause by
                                    the Customer shall not accrue any liabilities/responsibilities
                                    on Jazz including but not limited to liability/responsibility
                                    towards any loss occurred to the Customer/Participant;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="12">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.12</strong>  The language of the Campaign shall be Roman Urdu and/or
                                    English;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="13">
                            <li className="mbrules">
                                <p align="justify">
                                <strong>13.13</strong>  The Customer who has executed the agreement for availing Jazz
                                    Services against the MSISDN (cell number) under his use shall
                                    be eligible to participate in the Campaign and not otherwise.
                                    However, notwithstanding anything contained herein, the
                                    following shall not be eligible to participate in the Campaign:
                                </p>
                            </li>
                        </li>
                    </li>
                    <ul >
                        <li className="mbrules">
                            <p align="justify">
                                The employees of Jazz;
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                Jazz Franchises and Retailers and the employees of its sister
                                concerns;
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                    The spouse, children, parents and siblings (            <strong>“First Degree Relatives”</strong>) of Jazz employees;
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                The registered users of Jazz employee family number; and
                            </p>
                        </li>
                        <li className="mbrules">
                            <p align="justify">
                                The contractors, technical service providers and/or professionals
                                and their employees working for this Campaign.
                            </p>
                        </li>
                    </ul>
                    <li className="mbrules">
                        <li className="mbrules">
                            <p align="justify">
                                <strong>
                                    14. COMPLAINT/QUERY HANDLING, DISPUTE RESOLUTION AND ARBITRATION:
                                </strong>
                            </p>
                        </li>
                    </li>
                    <p align="justify">
                        <b>  14.1</b>  The Participant can call at the helpline by dialing 300 round the
                        clock for any complaints regarding the Campaign. The Participant’s call
                        shall be recorded against his CLI for record keeping and in accordance with
                        the instructions given by PTA. Prescribed tariff rates shall be charged for
                        using the helpline services;
                    </p>
                    <li className="mbrules">
                        <li className="mbrules">
                            <li className="mbrules">
                                <p align="justify">
                                <b>14.2</b>  If a Participant requires information regarding the Campaign or
                                    the Trivia, he can access FAQ, Game Rules &amp; detailed
                                    T&amp;C available on Jazz Cricket mobile app and web;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="2">
                            <li className="mbrules">
                                <p align="justify">
                                <b>14.3</b>  A Participant can check his rank by accessing the leaderboard
                                    available on the Jazz Cricket mobile app and web;
                                </p>
                            </li>
                        </li>
                    </li>
                    <li className="mbrules">
                        <li start="3">
                            <li className="mbrules">
                                <p align="justify">
                                <b>14.4</b>  The Campaign and/or the Trivia and these Terms and Conditions
                                    shall be governed by the laws of Pakistan and interpreted in
                                    accordance with laws of Pakistan. If the Participant shall be
                                    of the opinion that he has any right pertaining to the Campaign
                                    and he wishes to invoke such right, the Participant
                                    acknowledges, understands and agrees that such right can only
                                    be invoked through the arbitration which shall be conducted by
                                    the sole arbitrator appointed by Jazz and such arbitration
                                    proceedings shall be conducted in English or Urdu language at
                                    Lahore under the Arbitration Act 1940. Without prejudice to the
                                    above, it is further agreed by the Participant that only the
                                    courts at Lahore shall have the jurisdiction on any matter
                                    relating to the Campaign.
                                </p>
                            </li>
                        </li>
                    </li>
            
                </div>
            )
        } else {
            return ""
        }
    }
}

export default TermsnConditions;